import { Component, OnInit, ViewChild, Input, AfterViewInit } from '@angular/core';
import { AuthMapService } from '../../services/auth-map.service';
import { GoogleMapService } from '../../services/google-map.service';
import { OpenlayerMapService } from '../../services/openlayer-map.service';
import { CommonService } from '../../services/common.service';
import { AjaxService } from '../../services/ajax.service';
import { app, languageInitializer, serverUrl, storageVariable } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { ModalController, NavParams, Platform } from '@ionic/angular';
import Overlay from 'ol/Overlay';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { ActivatedRoute, Router } from '@angular/router';
import { jqxComboBoxComponent } from 'jqwidgets-ng/jqxcombobox';
// import { language } from 'src/app/services/language';
import { TranslateService } from '@ngx-translate/core';
// import { TrackDistanceComponent } from 'src/app/components/track-distance/track-distance.component';
// import { log } from 'util';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-vts-trackhistory',
  templateUrl: './vts-trackhistory.component.html',
  styleUrls: ['./vts-trackhistory.component.scss'],
  providers: [DatePipe],
  animations: [trigger('fadeIn', [transition(':enter', [
    style({
      opacity: 0
    }),
    animate('1s ease-in', style({ opacity: 1 }))
  ])]), trigger('fadeOut', [transition(':leave', [
    style({
      opacity: 1,
    }),
    animate('1s ease-out', style({ opacity: 0 }))
  ])])]
})
export class VtsTrackhistoryComponent implements OnInit, AfterViewInit {

  @ViewChild('mapElement', { static: false }) mapElement;
  @ViewChild('myGrid', { static: false }) myGrid: jqxGridComponent;
  @ViewChild("plateNoComobox", { static: false }) plateNoComobox: jqxComboBoxComponent;
  header: HTMLElement;
  directory = languageInitializer.directory
  btns: HTMLCollectionOf<Element>;
  header1: HTMLElement;
  btns1: HTMLCollectionOf<Element>;
  trackIdDis: string = "none";
  trackAlertDis: string = "none";
  mobileTrackDiv: string = "block";
  traveVinData;
  show = true;
  showHistoryCard = false;
  stopTrackHistoryArray = [];
  timeStampArray = [];
  maxSpeed = [];
  odometerArray = []
  cardShow: boolean = false;
  multiURL: boolean = false;
  mobileDate: any;
  dateTime: any;
  colorTrack: any;
  plateCard: string = ""
  replacedtoDate: any;
  replacedfromDate: any;
  showdataMarker = {
    stop: true,
    idle: true,
    running: false,
    overSpeed: false,
    towed: false,
    outofzone: true,
    working: false,
    poweron: true,
    powercut: true,
    lowbattery: false,
    BatteryDrain: false,
    movement: false
  }
  color = {
    'Idle': '#1f5baa',
    'Running': '#1eb15d',
    'Stop': '#FF0000',
    'Yet_to_transmit': '#7d410f',
    'No Transmission': '#000000',
    'Online': '#00E1BC',
    'Overspeed': '#f28918',
    'DoorOpen': '#FF851B',
    'HighTemp': '#FF0000',
    "PowerFail": '#412525',
    'Geofence': '#1f5baa',
    'Good': '#1eb15d',
    'Towed': '#ec268f',
    'StandBy': '#f4d642',
    "Working": "#1eb15d",
    "Out_Of_Zone": "#FF0000"
  }
  radio: String = ""
  popupView = false;
  popUp: any;
  trackHistoryCurrentRes: any;
  source: { localdata: any; };
  renderer: (row: number, column: any, value: string) => string;
  tableData: any;
  dataAdapter: any;
  columns: (void | { text: string; datafield: string; cellsrenderer: any; })[];
  userSelected: any = {
    "vin": "",
    "fromDate": "",
    "toDate": "",
    "fromTime": "",
    "toTime": ""
  };
  showPlateNo: boolean = true;
  plateNoList: any[];
  plateNoSelected: any = "";
  selectedLayout: any = "map";
  showHideRangeArrow: boolean = false;
  plateNos: any;
  entrypoint: any;
  geofenceCreatedList: any[];
  dashboardJson = [];
  data: any;
  allAlts: any[] = [];
  showData: any;
  intervalvalues: any = "Minutes";
  ngStop: any = 0;
  minutes: number = 0;
  seperateUrlLogin: Boolean = false;
  urlpresentAlert: boolean = true;
  Gridview: boolean = false;
  Gridview1: boolean = false;
  platWidth: string = '23%';
  platMargin: string = "2%";
  arrayTrack = [];
  vins: any
  toggleShow: boolean = false;
  statusVehicle: boolean = false;
  hideDist: boolean = false;
  MaxDate;
  pageSelector: any;
  gridheight: number;
  gpsEnable: boolean = false;
  gsmEnable: boolean = false;
  isTeltonika: boolean = false;
  vehoerationcode: any[] = [];
  vehoerationcodesourcs: any[] = [];
  callsign: any;
  callsignfilter: any;
  convertAddress: any;

  showSpeedSelector: boolean = false;
  speedOptions = [
    { label: '0.5x', value: 125 },
    { label: '0.75x', value: 250 },
    { label: '1x', value: 500 },
    { label: '1.5x', value: 750 },
    { label: '2x', value: 1000 }
  ];
  playBackSpeed: number = 500;
  selectedSpeed: string = '1x';
  showspeedicon = true;
  constructor(
    public mapService: AuthMapService,
    private datePipe: DatePipe,
    private commonService: CommonService,
    private ajaxService: AjaxService,
    private platform: Platform,
    private router: Router,
    private trans: TranslateService,
    private modalController: ModalController,
    private clipboard: Clipboard,
    private route: ActivatedRoute
  ) {
    if (localStorage.map == "GoogleMap") {
      this.mapService = new GoogleMapService();
    }
    else {
      this.mapService = new OpenlayerMapService();
    }
    this.MaxDate = new Date().toISOString().slice(0, 16);
  }
  ngAfterViewInit() {
    if (this.commonService.myPlatform != "desktop") {
      if (this.seperateUrlLogin)
        this.seprateCard('none')
    }
  }
  toggleSpeedSelector() {
    this.showSpeedSelector = !this.showSpeedSelector;
  }

  selectSpeed(speed: number) {
    this.playbackSpeedTrigger(speed);
    this.selectedSpeed = this.speedOptions.find(option => option.value === speed).label;

    this.showSpeedSelector = false; // Hide selector after selection
  }
  ionViewWillEnter() {
    this.popUp = (res) => {
    }
    setTimeout(() => {
      this.map.setTarget(this.mapElement.nativeElement);
      // this.plateNoComobox.selectItem("TEJARAT7560")
    }, 2000);
  }

  map: any;
  selectedVin: any = {};
  @Input() gridLiveChange;
  @Input() type
  user: any = {};
  selectedValue = 'today';
  displayPlay: boolean;
  displayPause: boolean;
  displayStop: boolean;
  liveCount;
  showSwipeModal: boolean = true;
  trackHistoryJson = [];
  playback;
  playbackIcon;
  interval;
  markerAddress;
  display = "play";
  playbackUpdater = {
    status: false,
    "timeStamp": "",
    "speed": "",
    "odometer": ""
  }
  markerInfo = {
    "show": false,
    "status": "",
    "speed": '',
    "duration": '',
    "timeStamp": ''
  };
  DateDesktop: any;
  range = '62';
  playBackOdometer: number = 0;
  hide: boolean = false;
  createMap() {
    setTimeout(() => {
      const defaultLocation: any = localStorage.getItem("defaultLocation");
      const [latitudeStr, longitudeStr]: string[] = defaultLocation.split(',');
      const latitude: number = parseFloat(latitudeStr);
      const longitude: number = parseFloat(longitudeStr);
      if (this.gridLiveChange == undefined || this.map == undefined) {
        this.map = this.mapService.loadMap(this.mapElement.nativeElement, { lat: this.traveVinData.latitude, lng: this.traveVinData.longitude }, false, false);
        if (defaultLocation != "") {
          this.mapService.setCenter(this.map, { lat: latitude, lng: longitude });
        } else {
          this.mapService.setCenter(this.map, { lat: 24.698619318986992, lng: 46.704241488514064 });
        }
      }
      if (this.commonService.myPlatform == "desktop" && this.type != "Multi Track") {
        this.getInBetweenDate()
      } else {
        this.getHistory();
      }
    }, 500);

  }

  getAddress(lat, lng) {
    const url = serverUrl.web + "/login/company/latlngtoaddress/" + lat + "/" + lng + "/" + localStorage.corpId + "/" + localStorage.lang;
    this.ajaxService.ajaxGetObject(url)
      .subscribe(res => {
        if (res.length > 5) {
          this.markerAddress = res;
        }
        else {
          this.markerAddress = "---";
        }
      });
  }
  toggleView() {
    this.showSwipeModal = !this.showSwipeModal;
    setTimeout(() => {
      if (this.plateNoComobox != undefined)
        this.plateNoComobox.selectItem(this.selectedVin.vin)
    }, 500);
    if (this.pageSelector == 'Multi Track')
      setTimeout(() => {
        if (this.myGrid != undefined)
          this.myGrid.columnsheight(15)
      }, 1000);
  }

  closemodal() {
    this.modalController.dismiss()
  }
  toggleViews() {
    this.toggleShow = !this.toggleShow;

  }

  trackModal(selectedData) {
    let date = new Date();
    let toTime = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toJSON();
    let url;
    this.selectedValue = selectedData;
    if (typeof (selectedData) == "number") {
      date.setHours(date.getHours() - selectedData);
      this.user = {
        "fromDate": new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toJSON(),
        "toDate": toTime.split(".")[0],
      }
    } else {
      let fromTime = '00:00:00'
      if (selectedData === 'today') {
        this.user = {
          "fromDate": (new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toJSON()).split('T')[0] + 'T' + fromTime,
          "toDate": toTime.split("T")[0] + 'T' + date.toTimeString().split(' ')[0],
        }
      } else if (selectedData === 'yesterday') {
        let yesterday = new Date(date.setDate(date.getDate() - 1));
        this.user = {
          "fromDate": (new Date(yesterday.getTime() - (yesterday.getTimezoneOffset() * 60000)).toJSON()).split('T')[0] + 'T' + fromTime,
          "toDate": (new Date(yesterday.getTime() - (yesterday.getTimezoneOffset() * 60000)).toJSON()).split('T')[0] + 'T23:59:59'
        }
      }
      // this.MaxDate=this.user.fromDate

    }
  }
  track(mode) {
    if (mode == 'stop') {
      this.showdataMarker.stop = !this.showdataMarker.stop;
      this.stopColor()
    } else if (mode == 'idle') {
      this.showdataMarker.idle = !this.showdataMarker.idle
    } else if (mode == 'overspeed') {
      this.showdataMarker.overSpeed = !this.showdataMarker.overSpeed
    } else if (mode == 'running') {
      this.showdataMarker.running = !this.showdataMarker.running
    } else if (mode == 'towed') {
      this.showdataMarker.towed = !this.showdataMarker.towed
    } else if (mode == 'outofzone') {
      this.showdataMarker.outofzone = !this.showdataMarker.outofzone
    } else if (mode == 'working') {
      this.showdataMarker.working = !this.showdataMarker.working
    } else if (mode == 'poweron') {
      this.showdataMarker.poweron = !this.showdataMarker.poweron
    } else if (mode == 'powercut') {
      this.showdataMarker.powercut = !this.showdataMarker.powercut
    } else if (mode == 'lowbattery') {
      this.showdataMarker.lowbattery = !this.showdataMarker.lowbattery
    } else if (mode == 'BatteryDrain') {
      this.showdataMarker.BatteryDrain = !this.showdataMarker.BatteryDrain
    } else if (mode == 'movement') {
      this.showdataMarker.movement = !this.showdataMarker.movement
    }
    console.log("showdataMarker", this.showdataMarker);
    if ((this.gpsEnable) && (!this.showdataMarker.stop || !this.showdataMarker.idle || !this.showdataMarker.running || !this.showdataMarker.overSpeed || !this.showdataMarker.towed)) {
      this.strength("gps")
    } else if ((this.gsmEnable) && (!this.showdataMarker.stop || !this.showdataMarker.idle || !this.showdataMarker.running || !this.showdataMarker.overSpeed || !this.showdataMarker.towed)) {
      this.strength("gsm")
    }

    this.mapService.clearLayers(this.map, [1])
    this.plotMarkers("")
    this.plotChangeMarker();
  }



  stopColor() {
    let colorArray = ['grey', 'blue', 'brown', 'orange', 'indigo', 'green', 'purple', 'red', 'white'];
    if (this.intervalvalues == "Hours") {
      this.minutes = this.ngStop * 60
    }
    else {
      this.minutes = this.ngStop
    }
    this.arrayTrack = [];
    if (sessionStorage.color && this.seperateUrlLogin) {

      this.mapService.createLine_stop(this.map, this.stopTrackHistoryArray, sessionStorage.color);
    }
    else {
      this.mapService.createLine(this.map, this.stopTrackHistoryArray);
    }
    if (!this.showdataMarker.stop || this.statusVehicle) {
      this.cardShow = false;
      return null;
    }
    let startIndex;
    let json = this.trackHistoryJson;
    let startEndIndex = [];
    var stop: boolean = false;
    for (let cnt = 1; cnt < this.trackHistoryJson.length - 1; cnt++) {
      startIndex = undefined;
      let source = {
        lat: parseFloat(json[cnt]['latitude']),
        lng: parseFloat(json[cnt]['longitude'])
      };

      let icon = 'assets/trackHistoryIcons/oldblue.png';
      const diffMin = this.commonService.secondstoHHMMSSCal(
        new Date(json[cnt + 1]['timeStamp']), new Date(json[cnt]['timeStamp']));
      if (json[cnt]['vehicleStatus'] == "Stop" && this.showdataMarker.stop == true) {
        json[cnt]["duration"] = diffMin;
        var a = diffMin.split(':');
        var minutes = (+a[0]) * 60 + (+a[1]);
        if (this.ngStop == 0) {
          this.cardShow = false;
          return null;
        }
        else if (this.minutes <= minutes) {
          stop = true;
          startIndex = cnt;
        }
      }
      if (startIndex != null && startIndex != undefined)
        startEndIndex.push(startIndex)
    }
    let end = startEndIndex.length;
    let slicedArr = [];
    let j = 0;
    if (startEndIndex.length !== 0) {
      for (let i = 0; i < end; i++) {
        slicedArr = this.stopTrackHistoryArray.slice(startEndIndex[i], startEndIndex[i + 1]);
        this.mapService.createLine_stop(this.map, slicedArr, colorArray[j]);
        if (i + 1 >= end && slicedArr.length < 20) {
          break;
        }
        let timeStamp = this.timeStampArray.slice(startEndIndex[i], startEndIndex[i + 1]);
        timeStamp.shift();
        const difference = new Date(`2000-01-01 ${this.timeStampArray[startEndIndex[i + 1]] == undefined ? this.datePipe.transform(this.user.toDate, 'h:mm:ss a') : this.timeStampArray[startEndIndex[i + 1]]}`).getTime() - new Date(`2000-01-01 ${timeStamp[0]}`).getTime();
        const seconds = Math.floor(difference / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        let time = (isNaN(difference)) ? '---' : `${hours}:${minutes % 60}:${seconds % 60}`;
        let odometer = this.odometerArray.slice(startEndIndex[i], startEndIndex[i + 1])
        let GrossDist = odometer.reduce((a, b) => a + b);
        GrossDist = (GrossDist > 0 && GrossDist < 1) ? GrossDist.toFixed(3) : parseInt(GrossDist)
        let maxSpeed = this.maxSpeed.slice(startEndIndex[i], startEndIndex[i + 1]);
        this.arrayTrack.push({ color: colorArray[j], startTime: timeStamp[0], endTime: this.timeStampArray[startEndIndex[i + 1]] == undefined ? this.datePipe.transform(this.user.toDate, 'h:mm:ss a') : this.timeStampArray[startEndIndex[i + 1]], duration: time, maxSpeed: Math.max(...maxSpeed), distance: GrossDist })
        if (j < 7) {
          j++;
        } else {
          j = 0;
        }
      }
    }
    if (this.trackHistoryJson.length !== 0 && this.arrayTrack.length !== 0) {
      this.hide = this.commonService.myPlatform != 'desktop' ? false : this.hide;
      this.cardShow = true;
      this.plateCard = this.selectedVin.plateNo
    }
    else {
      this.cardShow = false;
    }
  }


  copylinK(start, end, color) {
    this.multiURL = true;
    this.colorTrack = color;
    const date1 = new Date(`1/1/2000 ${start}`);
    date1.setSeconds(date1.getSeconds() - 1);
    const startTime = this.datePipe.transform(date1, 'HH:mm:ss');
    const date2 = new Date(`1/1/2000 ${end}`);
    date1.setSeconds(date2.getSeconds() - 1);
    const endTime = this.datePipe.transform(date2, 'HH:mm:ss');
    this.dateTime = this.userSelected.fromDate.split(" ")[0] + "T" + startTime + "#" + this.userSelected.toDate.split(" ")[0] + "T" + endTime
    let date = this.dateTime.split('#');
    this.mobileDate = this.DateDesktop + date[0] + "#" + this.DateDesktop + date[1]
    this.token()
  }

  toggleCard(data) {
    if (data == "open") {
      if (this.trackHistoryJson.length !== 0 && this.arrayTrack.length !== 0) {
        this.cardShow = true;
      }
    } else if (data == "close") {
      this.cardShow = false;
    }
  }
  changePlateNo() {
    if (this.plateNoComobox.getSelectedItem() != null) {

      let vin = this.plateNoComobox.getSelectedItem().value
      this.selectedVin = storageVariable.dashboardData.liveDatas[vin];
      this.traveVinData = storageVariable.dashboardData.liveDatas[vin];

      if (this.selectedVin.vin != vin)
        this.getInBetweenDate();
    }
  }


  switchMap(data, map) {
    this.selectedLayout = map;
    this.map.getLayers().item(3).setVisible(data);
    this.map.getLayers().item(0).setVisible(!data)
  }
  generateDateRanges(fromDate: string, fromTime: string, toDate: string, toTime: string): string[] {
    const startDate = new Date(`${fromDate} ${fromTime}`);
    const endDate = new Date(`${toDate} ${toTime}`);
    const result: string[] = [];

    let currentDate = new Date(startDate);

    while (currentDate < endDate) {
      const startOfDay = new Date(currentDate);
      const endOfDay = new Date(currentDate);
      endOfDay.setHours(23, 59, 59, 999);

      if (endOfDay > endDate) {
        endOfDay.setHours(endDate.getHours(), endDate.getMinutes(), endDate.getSeconds(), endDate.getMilliseconds());
      }

      result.push(`${this.formatDate(startOfDay)}#${this.formatDate(endOfDay)}`);

      // Move to the next day
      currentDate.setDate(currentDate.getDate() + 1);
      currentDate.setHours(0, 0, 0, 0);
    }

    return result;
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = date.getHours() % 12 || 12;
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const ampm = date.getHours() < 12 ? 'AM' : 'PM';
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${ampm}`;
  }
  getInBetweenDate() {
    // this.closeDiv("track-id");
    // this.closeDiv("track-Alert");
    this.vins = this.selectedVin.vin;
    this.commonService.presentLoader();
    this.display = "play";
    this.moveVehicleInMap('stop', '');
    if (this.mapService)
      this.mapService.clearLayers(this.map, [1, 2])
    // const url = serverUrl.web + '/trackHistory/trackhistoryVTS';
    // const body = {
    //   "vin": this.selectedVin.vin
    //   , "fromDate": this.datePipe.transform(this.user.fromDate, 'yyyy-MM-dd'),
    //   "toDate": this.datePipe.transform(this.user.toDate, 'yyyy-MM-dd'),
    //   "fromTime": this.datePipe.transform(this.user.fromDate, 'h:mm:ss a'),
    //   "toTime": this.datePipe.transform(this.user.toDate, 'h:mm:ss a')
    // }
    const dateRanges = this.generateDateRanges(this.datePipe.transform(this.user.fromDate, 'yyyy-MM-dd'), this.datePipe.transform(this.user.fromDate, 'h:mm:ss a'),
      this.datePipe.transform(this.user.toDate, 'yyyy-MM-dd'), this.datePipe.transform(this.user.toDate, 'h:mm:ss a'));
    console.log(dateRanges);
    // // this.MaxDate=this.user.fromDate
    // this.ajaxService.ajaxPostMethod(url, body)
    //   .subscribe(res => {


    if (dateRanges.length > 0) {
      this.urlpresentAlert = false;
      let data = []

      for (let i = 0; i < dateRanges.length; i++) {
        data.push({ "From": dateRanges[i].split('#')[0], "To": dateRanges[i].split('#')[1] })
      }
      this.renderer = (row: number, column: any, value: string,) => {
        if (value == "" || null || undefined) {
          return "----"
        }
        else {
          return '<span style="line-height:32px;font-size:11px;color:darkblue;margin:auto;padding:0px 5px">' + value + '</span>';
        }
      }
      this.source = { localdata: data };
      this.dataAdapter = new jqx.dataAdapter(this.source);
      this.columns = [
        { text: this.trans.instant("From Date"), datafield: 'From', cellsrenderer: this.renderer },
        { text: this.trans.instant("To Date"), datafield: 'To', cellsrenderer: this.renderer }
      ]
      this.myGrid.updatebounddata();
      setTimeout(() => {
        this.myGrid.selectrow(0)

      }, 1000);
      if (this.pageSelector == 'Multi Track')
        setTimeout(() => {
          this.myGrid.columnsheight(15)
        }, 1000);
    } else {
      this.trackHistoryJson = [];
      this.cardShow = false;
      this.closeDiv("track-id");

      if (this.commonService.myPlatform == "desktop") {
        this.userSelected.fromDate = this.datePipe.transform(this.user.fromDate, 'yyyy-MM-dd') + " " + this.datePipe.transform(this.user.fromDate, 'HH:mm:ss')
        this.userSelected.toDate = this.datePipe.transform(this.user.toDate, 'yyyy-MM-dd') + " " + this.datePipe.transform(this.user.toDate, 'HH:mm:ss')
        if (this.type == "Multi Track")
          this.commonService.presentAlert("No data", "Data not available" + " For " + this.selectedVin.plateNo);
        else
          this.commonService.presentAlert("No data", "Data not available");
        this.urlpresentAlert = false;
      }
      // else{this.urlpresentAlert = false} 
      this.source = { localdata: [] };
      this.dataAdapter = new jqx.dataAdapter(this.source);
      this.commonService.dismissLoader()
    }
    // })

  }
  createFreeForm(selectedRow) {
    let data = selectedRow.latlng;
    let latLngData = [];
    if (selectedRow.latlng) {
      for (let i in data) {
        var latlng = data[i];
        latLngData.push({
          latitude: latlng.split(",")[0],
          longitude: latlng.split(",")[1],
        });
      }
      latLngData.push({
        latitude: data[0].split(",")[0],
        longitude: data[0].split(",")[1],
      });
      this.mapService.setRoadLineString(this.map, latLngData);
    }
  }
  myGridOnRowSelect($event) {
    this.closeDiv("track-id")
    this.closeDiv("track-Alert")
    this.commonService.presentLoader();
    if ($event.args.row == undefined) {
      this.userSelected.fromDate = this.datePipe.transform(this.user.fromDate, 'yyyy-MM-dd') + " " + this.datePipe.transform(this.user.fromDate, 'HH:mm:ss')
      this.userSelected.toDate = this.datePipe.transform(this.user.toDate, 'yyyy-MM-dd') + " " + this.datePipe.transform(this.user.toDate, 'HH:mm:ss')

    } else {
      this.userSelected.fromDate = this.datePipe.transform($event.args.row.From, 'yyyy-MM-dd') + " " + this.datePipe.transform($event.args.row.From, 'HH:mm:ss')
      this.userSelected.toDate = this.datePipe.transform($event.args.row.To, 'yyyy-MM-dd') + " " + this.datePipe.transform($event.args.row.To, 'HH:mm:ss')
    }
    this.getHistory()
  }

  downloadKML() {
    let url = serverUrl.web + "/trackHistory/generateKMLServlet?name=BackTracking&selectedVehicle=" + this.selectedVin.vin +
      "&fromDate=" + this.datePipe.transform(this.userSelected.fromDate, 'yyyy-MM-dd') + " " + this.datePipe.transform(this.userSelected.fromDate, 'HH:mm:ss')
      + "&toDate=" + this.datePipe.transform(this.user.toDate, 'yyyy-MM-dd') + " " + this.datePipe.transform(this.userSelected.toDate, 'HH:mm:ss') +
      "&compName=" + localStorage.corpId + "&brnchName=" + localStorage.corpId + "&userName=" + localStorage.userName
      + "&selectedVehiPlateNo=" + this.selectedVin.plateNo + '&entryPoint=' + app.entryPoint
    this.ajaxService.ajaxGetObject(url).subscribe(res => {
      if (res == "") {
        this.commonService.presentToast("your data is empty, unable to download empty data.")
      } else {
        var hiddenElement = document
          .createElement('a');
        hiddenElement.href = 'data:text/kml;charset=utf-8,' + encodeURIComponent(res);
        hiddenElement.target = '_blank';
        hiddenElement.download = "KML_" + this.selectedVin.plateNo + "_" + this.datePipe.transform(this.userSelected.fromDate, 'yyyy-MM-dd') + "_" + this.datePipe.transform(this.user.toDate, 'yyyy-MM-dd') + ".kml";
        hiddenElement.click();
      }
    })

  }
  showPinDetails(feature, evt, arg3) {
    (arg3 == null) ? this.convertAddress = feature.values_.name.address : this.convertAddress = arg3;
    const container = document.getElementById('popup');
    const content = document.getElementById('popup-content');
    const closer = document.getElementById('popup-closer');
    const overlay = new Overlay({
      element: container,
      autoPan: true,
      autoPanAnimation: {
        duration: 0
      }
    });
    let T1 = feature.values_.name.temp1 != "" ? ("TEMP1 :" + feature.values_.name.temp1) + ';' : "",
      T2 = feature.values_.name.temp2 != "" ? ("TEMP2 :" + feature.values_.name.temp2) + ';' : "",
      T3 = feature.values_.name.temp3 != "" ? ("TEMP3 :" + feature.values_.name.temp3) + ';' : "",
      T4 = feature.values_.name.temp4 != "" ? ("TEMP4 :" + feature.values_.name.temp4) + ';' : "",
      BT1 = feature.values_.name.bltemp1 != "" ? ("BTEMP1 :" + feature.values_.name.bltemp1) + ';' : "",
      BT2 = feature.values_.name.bltemp2 != "" ? ("BTEMP2 :" + feature.values_.name.bltemp2) + ';' : "",
      BT3 = feature.values_.name.bltemp3 != "" ? ("BTEMP3 :" + feature.values_.name.bltemp3) + ';' : "",
      BT4 = feature.values_.name.bltemp4 != "" ? ("BTEMP4 :" + feature.values_.name.bltemp4) + ';' : "",
      BH1 = feature.values_.name.blueHumidity1 != "" ? ("HUMIDITY1 :" + feature.values_.name.blueHumidity1) + ';' : "",
      BH2 = feature.values_.name.blueHumidity2 != "" ? ("HUMIDITY2 :" + feature.values_.name.blueHumidity2) + ';' : "",
      BH3 = feature.values_.name.blueHumidity3 != "" ? ("HUMIDITY3 :" + feature.values_.name.blueHumidity3) + ';' : "",
      BH4 = feature.values_.name.blueHumidity4 != "" ? ("HUMIDITY4 :" + feature.values_.name.blueHumidity4) + ';' : "";
    let t = [T1, T2, T3, T4, BT1, BT2, BT3, BT4, BH1, BH2, BH3, BH4];
    this.map.addOverlay(overlay);
    const coordinate = evt.coordinate;
    let backgroundColor = "#2563eb";
    if (feature.values_.name.vehicleStatus === "Idle") {
      backgroundColor = "#1f5baa";
    } else if (feature.values_.name.vehicleStatus === "Stop") {
      backgroundColor = "#FF0000";
    }
    else if (feature.values_.name.vehicleStatus === "Running") {
      backgroundColor = "#1eb15d";
    }
    else if (feature.values_.name.vehicleStatus === "Overspeed") {
      backgroundColor = "#f28918";
    }
    else if (feature.values_.name.vehicleStatus === "Towed") {
      backgroundColor = "#c200b8";
    }

    content.innerHTML = `
<h2 style="
    margin-bottom: -26px;
    border: 1px solid ${backgroundColor};
    margin-top: -1px;
    background-color: ${backgroundColor};
    font-size: 23px;
    width: -webkit-fill-available;
    border-radius: 10px 10px 0px 0px;
    text-transform: uppercase;
    text-align: center;">
  ${(app.entryPoint === "WFT" && feature.values_.name.vehicleStatus === "Towed")
        ? this.trans.instant("Idle out of zone")
        : this.trans.instant(feature.values_.name.vehicleStatus)}
</h2><br>`;
    if (feature.values_.name.vehicleStatus == 'Idle' || feature.values_.name.vehicleStatus == 'Stop' || feature.values_.name.vehicleStatus == 'Out_Of_Zone')
      content.innerHTML += '<p style="text-transform: uppercase">  <span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' + this.trans.instant(feature.values_.name.vehicleStatus) + ' ' + this.trans.instant('FOR') + ': </span>' + this.commonService.numberToArabic(feature.values_.name.duration);

    // content.innerHTML += '<p>  <span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' + this.trans.instant('TIME') + ': </span>' + this.commonService.numberToArabic(feature.values_.name.timeStamp) + '</p><p style="margin-top: -11px;">  <span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' + this.trans.instant('SPEED') + ':  </span>' +
    //   this.commonService.numberToArabic(feature.values_.name.speed) +
    //   '</p>' + '</p><p style="margin-top: -11px;margin-left: 5px;"> <span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;">' + this.trans.instant('LOCATION') + ': </span> ' + `${this.convertAddress}` +
    //   '</p>' + '</p><p style="margin-top: -11px;">  <span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' + this.trans.instant('GPS') + ': </span> ' + this.commonService.numberToArabic(feature.values_.name.gps || '---') +
    //   '</p>' + '</p><p style="margin-top: -11px;">  <span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' + this.trans.instant('GSM') + ':</span>  ' + this.commonService.numberToArabic(feature.values_.name.gsm || '---') +
    //   '</p>' + '</p><p style="margin-top: -11px;">  <span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' + this.trans.instant('CURRENT WEIGHT') + ': </span> ' + this.commonService.numberToArabic(feature.values_.name.loadWeight || '---') +
    //   '</p>' + '</p><p style="margin-top: -11px;">  <span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' + this.trans.instant('TOTAL WEIGHT') + ':</span>  ' + this.commonService.numberToArabic(feature.values_.name.totalWeight || '---') + '</p>';
    let htmlContent = '';

    htmlContent += '<p><span style="font-weight: 500; text-transform: uppercase; margin: 0 5px;">' + this.trans.instant('TIME') + ': </span>' +
      this.commonService.numberToArabic(feature.values_.name.timeStamp) + '</p>';
    if (app.entryPoint !== 'WFT') {
      htmlContent += '<p style="margin-top: -11px;"><span style="font-weight: 500; text-transform: uppercase; margin: 0 5px;">' + this.trans.instant('SPEED') + ': </span>' +
        this.commonService.numberToArabic(feature.values_.name.speed) + '</p>';
    }


    // htmlContent += '<p style="margin-top: -11px; margin-left: 5px;"><span style="font-weight: 500; text-transform: uppercase; margin-right: 5px;">' + this.trans.instant('LOCATION') + ': </span>' +
    //   `${this.convertAddress}` + '</p>';

    const lat = feature.values_.name.address.split(",")[0];
    const lng = feature.values_.name.address.split(",")[1];
    const mapsLink = `https://www.google.com/maps?q=${lat},${lng}`;

    htmlContent += `
  <p style="margin-top: -11px; margin-left: 5px;">
    <span style="font-weight: 500; text-transform: uppercase; margin-right: 5px;">
      ${this.trans.instant('LOCATION')}:
    </span>
    <a href="${mapsLink}" target="_blank" style="color: #2563eb; text-decoration: underline;">
      ${this.convertAddress}
    </a>
    <ion-icon class="copy-icon" data-link="${mapsLink}"
              name="copy"
              style="cursor: pointer; margin-left: 8px; font-size: 18px; vertical-align: middle;"
              title="Copy link">
    </ion-icon>
  </p>
`;

    // attach click event after content is rendered
    setTimeout(() => {
      const copyIcon = document.querySelector(".copy-icon");
      if (copyIcon) {
        copyIcon.addEventListener("click", () => {
          navigator.clipboard.writeText(mapsLink).then(() => {
            this.commonService.presentToast("Link Copied!");
          });
        });
      }
    }, 0);

    htmlContent += '<p style="margin-top: -11px;"><span style="font-weight: 500; text-transform: uppercase; margin: 0 5px;">' + this.trans.instant('GPS') + ': </span>' +
      this.commonService.numberToArabic(feature.values_.name.gps || '---') + '</p>';

    htmlContent += '<p style="margin-top: -11px;"><span style="font-weight: 500; text-transform: uppercase; margin: 0 5px;">' + this.trans.instant('GSM') + ': </span>' +
      this.commonService.numberToArabic(feature.values_.name.gsm || '---') + '</p>';



    if (app.entryPoint !== 'WFT') {
      htmlContent += '<p style="margin-top: -11px;"><span style="font-weight: 500; text-transform: uppercase; margin: 0 5px;">' + this.trans.instant('CURRENT WEIGHT') + ': </span>' +
        this.commonService.numberToArabic(feature.values_.name.loadWeight || '---') + '</p>';
      htmlContent += '<p style="margin-top: -11px;"><span style="font-weight: 500; text-transform: uppercase; margin: 0 5px;">' + this.trans.instant('TOTAL WEIGHT') + ': </span>' +
        this.commonService.numberToArabic(feature.values_.name.totalWeight || '---') + '</p>';
      htmlContent += '<p style="margin-top: -11px;"><span style="font-weight: 500; text-transform: uppercase; margin: 0 5px;">' + this.trans.instant('FUEL') + ': </span>' +
        this.commonService.numberToArabic(feature.values_.name.fuelLtr || '---') + ' Ltr' + '</p>';
    }

    content.innerHTML += htmlContent;


    content.innerHTML += '<p  style="margin-top: -11px;">' + `${T1} ${T2} ${T3} ${T4} ` + '</p>'
    content.innerHTML += '<p style="margin-top: -11px;">' + `${BT1} ${BT2} ${BT3} ${BT4} ` + '</p>'
    content.innerHTML += '<p style="margin-top: -11px;">' + `${BH1}  ${BH2}  ` + '</p>'
    content.innerHTML += '<p style="margin-top: -11px;">' + `${BH3} ${BH4} ` + '</p>'
    container.style.visibility = "visible";
    overlay.setPosition(coordinate);
    closer.onclick = function () {
      overlay.setPosition(undefined);
      closer.blur();
      return false;
    };
  }


  forStartEnd(feature, evt, arg3) {
    let location = arg3 == null ? feature.values_.name.address : arg3;
    const container = document.getElementById('popup');
    const content = document.getElementById('popup-content');
    const closer = document.getElementById('popup-closer');
    const overlay = new Overlay({
      element: container,
      autoPan: true,
      autoPanAnimation: {
        duration: 0
      }
    });
    this.map.addOverlay(overlay);
    const coordinate = evt.coordinate;

    // hussain
    if (feature.values_.name.status == 'Beginning of Trip') {
      content.innerHTML = `<h2 style="    margin-bottom: -26px;
    border: 1px solid  grey;
    margin-top: -1px;
    background-color:  grey;
    font-size: 23px;
    width: -webkit-fill-available;
    border-radius: 10px 10px 0px 0px;
    text-transform: uppercase;
    text-align: center;">` +
        this.trans.instant('START') + '</h2><br>';
      // content.innerHTML += '<p> <span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' + this.trans.instant('TIME') + ': </span>' + this.commonService.numberToArabic(feature.values_.name.timeStamp) + '</p><p style="margin-top: -11px;"> <span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' + this.trans.instant('SPEED') + ': </span>' +
      //   this.commonService.numberToArabic(feature.values_.name.speed) + '</p><p style="margin-top: -11px;margin-left: 5px;"><span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;">' + this.trans.instant('LOCATION') + ': </span>' + this.commonService.numberToArabic(location) +
      //   '</p>';
      let html = '';

      html += '<p><span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' +
        this.trans.instant('TIME') + ': </span>' +
        this.commonService.numberToArabic(feature.values_.name.timeStamp) + '</p>';

      // Add speed only if it's available and > 0
      if (this.entrypoint !== "WFT") {
        html += '<p style="margin-top: -11px;"><span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' +
          this.trans.instant('SPEED') + ': </span>' +
          this.commonService.numberToArabic(feature.values_.name.speed) + '</p>';
        html += '<p style="margin-top: -11px;"><span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' +
          this.trans.instant('FUEL') + ': </span>' +
          this.commonService.numberToArabic(feature.values_.name.fuelLtr || '---') + ' Ltr' + '</p>';
        
      }

      // html += '<p style="margin-top: -11px;margin-left: 5px;"><span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;">' +
      //   this.trans.instant('LOCATION') + ': </span>' +
      //   this.commonService.numberToArabic(location) + '</p>';


      const lat = feature.values_.name.address.split(",")[0];
      const lng = feature.values_.name.address.split(",")[1];
      const mapsLink = `https://www.google.com/maps?q=${lat},${lng}`;

      html += `
  <p style="margin-top: -11px; margin-left: 5px;">
    <span style="font-weight: 500; text-transform: uppercase; margin-right: 5px;">
      ${this.trans.instant('LOCATION')}:
    </span>
    <a href="${mapsLink}" target="_blank" style="color: #2563eb; text-decoration: underline;">
      ${location}
    </a>
    <ion-icon class="copy-icon" data-link="${mapsLink}"
              name="copy"
              style="cursor: pointer; margin-left: 8px; font-size: 18px; vertical-align: middle;"
              title="Copy link">
    </ion-icon>
  </p>
`;

      // attach click event after content is rendered
      setTimeout(() => {
        const copyIcon = document.querySelector(".copy-icon");
        if (copyIcon) {
          copyIcon.addEventListener("click", () => {
            navigator.clipboard.writeText(mapsLink).then(() => {
              this.commonService.presentToast("Link Copied!");
            });
          });
        }
      }, 0);

      // Assign the built HTML
      content.innerHTML += html;

    }
    else if (feature.values_.name.status == 'End of Trip') {
      content.innerHTML = `<h2 style="    margin-bottom: -26px;
    border: 1px solid  grey;
    margin-top: -1px;
    background-color:  grey;
    font-size: 23px;
    width: -webkit-fill-available;
    border-radius: 10px 10px 0px 0px;
    text-transform: uppercase;
    text-align: center;">
        ${this.trans.instant('END')}  </h2><br>`;
      // content.innerHTML += '<p><span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' + this.trans.instant('TIME') + ':</span>' + this.commonService.numberToArabic(feature.values_.name.timeStamp) + '</p><p style="margin-top: -11px;"><span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' + this.trans.instant('SPEED') + ':</span>' +
      //   this.commonService.numberToArabic(feature.values_.name.speed) + '</p><p style="margin-top: -11px;margin-left: 5px;"><span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;">' + this.trans.instant('LOCATION') + ':</span>' + this.commonService.numberToArabic(location) +
      //   '</p>';
      let html = '';

      html += '<p><span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' +
        this.trans.instant('TIME') + ':</span> ' +
        this.commonService.numberToArabic(feature.values_.name.timeStamp) + '</p>';

      if (this.entrypoint !== "WFT") {
        html += '<p style="margin-top: -11px;"><span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' +
          this.trans.instant('SPEED') + ':</span> ' +
          this.commonService.numberToArabic(feature.values_.name.speed) + '</p>';
        html += '<p style="margin-top: -11px;"><span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;margin-left: 5px;">' +
          this.trans.instant('FUEL') + ':</span> ' +
          this.commonService.numberToArabic(feature.values_.name.fuelLtr || '---') + ' Ltr' + '</p>';
      }
      // html += '<p style="margin-top: -11px;margin-left: 5px;"><span style="font-weight: 500;text-transform: uppercase;margin-right: 5px;">' +
      //   this.trans.instant('LOCATION') + ':</span> ' +
      //   this.commonService.numberToArabic(location) + '</p>';

      const lat = feature.values_.name.address.split(",")[0];
      const lng = feature.values_.name.address.split(",")[1];
      const mapsLink = `https://www.google.com/maps?q=${lat},${lng}`;

      html += `
  <p style="margin-top: -11px; margin-left: 5px;">
    <span style="font-weight: 500; text-transform: uppercase; margin-right: 5px;">
      ${this.trans.instant('LOCATION')}:
    </span>
    <a href="${mapsLink}" target="_blank" style="color: #2563eb; text-decoration: underline;">
      ${location}
    </a>
    <ion-icon class="copy-icon" data-link="${mapsLink}"
              name="copy"
              style="cursor: pointer; margin-left: 8px; font-size: 18px; vertical-align: middle;"
              title="Copy link">
    </ion-icon>
  </p>
`;

      setTimeout(() => {
        const copyIcon = document.querySelector(".copy-icon");
        if (copyIcon) {
          copyIcon.addEventListener("click", () => {
            navigator.clipboard.writeText(mapsLink).then(() => {
              this.commonService.presentToast("Link Copied!");
            });
          });
        }
      }, 0);
      content.innerHTML += html;

    } else {
      this.markerAddress = "---";
    }
    container.style.visibility = "visible";
    overlay.setPosition(coordinate);
    closer.onclick = function () {
      overlay.setPosition(undefined);
      closer.blur();
      return false;
    }
  }
  getHistory() {

    if (!this.commonService.isLoading)
      this.commonService.presentLoader();

    this.mapService.clearLayers(this.map, [1, 2])
    this.playbackUpdater.status = false;
    this.mapService.clearLayers(this.map, [1, 2]);

    var url;
    if (this.commonService.myPlatform == "desktop" && this.type != "Multi Track") {
      if (this.seperateUrlLogin == false) {
        url = serverUrl.web + '/device/trackhistory?vehicleNo=' + this.selectedVin.vin + '&fromDate=' + this.datePipe.transform(this.userSelected.fromDate, 'yyyy-MM-dd') +
          '&fromtime=' + this.datePipe.transform(this.userSelected.fromDate, 'HH:mm:ss') + '&totime=' + this.datePipe.transform(this.userSelected.toDate, 'HH:mm:ss') + '&entryPoint=' + app.entryPoint;
      }

      if (this.seperateUrlLogin == true) {
        // this.showHistoryCard = true;
        this.userSelected.fromDate = sessionStorage.getItem("fromDate")
        this.userSelected.toDate = sessionStorage.getItem("toDate")
        url = serverUrl.web + '/device/trackhistory?vehicleNo=' + this.selectedVin.vin + '&fromDate=' + this.datePipe.transform(this.userSelected.fromDate, 'yyyy-MM-dd') +
          '&fromtime=' + this.datePipe.transform(this.userSelected.fromDate, 'HH:mm:ss') + '&totime=' + this.datePipe.transform(this.userSelected.toDate, 'HH:mm:ss') + '&entryPoint=' + app.entryPoint;



      }
    } else {
      if (this.seperateUrlLogin == true) {
        this.user.fromDate = sessionStorage.getItem("fromDate")
        this.user.toDate = sessionStorage.getItem("toDate")
      }
      url = serverUrl.web + '/device/trackhistory?vehicleNo=' + this.selectedVin.vin + '&fromDate=' + this.datePipe.transform(this.user.fromDate, 'yyyy-MM-dd') +
        '&fromtime=' + this.datePipe.transform(this.user.fromDate, 'HH:mm:ss') + '&totime=' + this.datePipe.transform(this.user.toDate, 'HH:mm:ss') + '&entryPoint=' + app.entryPoint;

    }

    this.ajaxService.ajaxGet(url)
      .subscribe(res => {
        let assignedWorkZone;
        if (this.entrypoint == "WFT") {
          assignedWorkZone = this.selectedVin.empDetails.workZone == "null" ? [] : (this.selectedVin.empDetails.workZone).split(",")

        }
        this.trackHistoryCurrentRes = res;
        // this.trackHistoryCurrentRes = this.commonService.tempTrackRes;
        if (this.trackHistoryCurrentRes['routeGeometry'].length > 0)
          if (this.trackHistoryCurrentRes.routeGeometry[0].manufacturer == "Teltonika") this.isTeltonika = true;

        this.commonService.presentLoader();
        if (localStorage.map != "GoogleMap") {
          this.map.on('click', async (evt) => {
            evt.stopPropagation();
            let feature: any;
            var pixel = this.map.getEventPixel(evt);
            feature = await this.map.forEachFeatureAtPixel(evt.pixel, (feature) => {
              if (feature.values_.title == "lineString") {
                return feature;
              }
            });
            if (!feature)
              feature = evt.coordinate;
            //feature = this.map.getLayers().item(1).getSource().getClosestFeatureToCoordinate(evt.coordinate);
            if (feature.hasOwnProperty("values_")) {
              if (feature.values_.title == "lineString" && feature.values_.title !== "") {
                if (this.commonService.myPlatform == "desktop") {
                  if (!feature.values_.name.hasOwnProperty("status")) {
                    this.showPinDetails(feature, evt, null)
                  } else {
                    this.forStartEnd(feature, evt, null)
                  }

                } else {
                  this.traveVinData['status'] = feature.values_.name.vehicleStatus;
                  this.traveVinData['latitude'] = parseFloat(feature.values_.name.latitude);
                  this.traveVinData['longitude'] = parseFloat(feature.values_.name.longitude);
                  this.traveVinData['timeStamp'] = feature.values_.name.timeStamp;
                  this.traveVinData['speed'] = feature.values_.name.speed;
                  this.traveVinData['odometer'] = feature.values_.name.odometer;
                  this.traveVinData['location'] = location
                }


                const regex = /[a-zA-Z]/;
                if (!regex.test(feature.values_.name.address)) {
                  let urlForGetaddrs
                  if (!feature.values_.name.hasOwnProperty("status")) {
                    urlForGetaddrs = serverUrl.web + "/login/company/latlngtoaddress/" + feature.values_.name.latitude + "/" + feature.values_.name.longitude + "/" + localStorage.corpId + "/" + localStorage.lang;
                  } else {
                    urlForGetaddrs = serverUrl.web + "/login/company/latlngtoaddress/" + feature.values_.name.latlng.lat + "/" + feature.values_.name.latlng.lng + "/" + localStorage.corpId + "/" + localStorage.lang;
                  }

                  this.ajaxService.ajaxGetObject(urlForGetaddrs)
                    .subscribe(res => {
                      if (this.commonService.myPlatform == "desktop") {
                        if (!feature.values_.name.hasOwnProperty("status")) {
                          this.showPinDetails(feature, evt, res)
                        } else {
                          this.forStartEnd(feature, evt, res)
                        }

                      }


                    })

                }
              }
            }

            if (!feature) {
              this.markerInfo["show"] = false;
            }

          })
        }
        this.DateDesktop = this.datePipe.transform(this.user.fromDate, 'yyyy-MM-dd')
        this.trackHistoryData(res);
        if (this.entrypoint == "WFT") {
          assignedWorkZone.map(res => {
            if (this.geofenceCreatedList[res.split("#")[0] + "-freeForm"] && this.geofenceCreatedList[res.split("#")[0] + "-freeForm"].name == res.split("#")[1])
              this.createFreeForm({ latlng: this.geofenceCreatedList[res.split("#")[0] + "-freeForm"].latlng })
          })
        }
        setTimeout(() => this.mapService.fitBounds(this.map, 2), 500)

      })

  }
  strength(arg) {
    let tempArray = []
    this.trackHistoryJson.forEach(function (
      value) {
      if (value.latitude !== 0 && value.longitude !== 0) {
        tempArray.push({
          lat: value.latitude,
          lng: value.longitude
        });
      }
    })
    let fixCount = 2;
    if (arg == "gps") {
      (!this.gpsEnable) ? this.gpsEnable = true : this.gpsEnable = false;
      (this.gpsEnable) ? this.gsmEnable = false : "";


      for (let i = 0; i < this.trackHistoryJson.length; i++) {
        if (this.trackHistoryJson[i].gps < 11) {
          this.mapService.createLine_stop(this.map, tempArray.slice(i, (fixCount + i)), "red")
        } else if ((this.trackHistoryJson[i].gps > 10) && (this.trackHistoryJson[i].gps < 16)) {
          this.mapService.createLine_stop(this.map, tempArray.slice(i, (fixCount + i)), "orange")
        } else if ((this.trackHistoryJson[i].gps > 15) && (this.trackHistoryJson[i].gps < 21)) {
          this.mapService.createLine_stop(this.map, tempArray.slice(i, (fixCount + i)), "#faff23")
        } else if ((this.trackHistoryJson[i].gps > 20)) {
          this.mapService.createLine_stop(this.map, tempArray.slice(i, (fixCount + i)), "#31de31")
        }
      }
    }
    else if (arg == "gsm") {
      (!this.gsmEnable) ? this.gsmEnable = true : this.gsmEnable = false;
      (this.gsmEnable) ? this.gpsEnable = false : "";

      for (let i = 0; i < this.trackHistoryJson.length; i++) {
        if (this.trackHistoryJson[i].gsm == 2) {
          this.mapService.createLine_stop(this.map, tempArray.slice(i, (fixCount + i)), "red")
        } else if (this.trackHistoryJson[i].gsm == 3) {
          this.mapService.createLine_stop(this.map, tempArray.slice(i, (fixCount + i)), "orange")
        } else if (this.trackHistoryJson[i].gsm == 4) {
          this.mapService.createLine_stop(this.map, tempArray.slice(i, (fixCount + i)), "#faff23") //#50f254
        } else if (this.trackHistoryJson[i].gsm == 5) {
          this.mapService.createLine_stop(this.map, tempArray.slice(i, (fixCount + i)), "#31de31")
        }
      }
    }
    this.checkingPlotMarkers(['stop', 'idle', 'Speed']);

    (this.gpsEnable || this.gsmEnable) ? document.getElementById('colorsShow').style.display = 'block' : document.getElementById('colorsShow').style.display = 'none'

    if (!this.gpsEnable && !this.gsmEnable) this.getHistory();
  }




  showLocation(data) {
    const url = serverUrl.web + "/login/company/latlngtoaddress/" + data.latitude + "/" + data.longitude + "/" + localStorage.corpId + "/" + localStorage.lang;
    this.ajaxService.ajaxGetObject(url)
      .subscribe(res => {
        if (JSON.stringify(res) == "{}") {
          data.location = data.latitude + ',' + data.longitude;
        } else {
          data.location = res;
        }

      });
  }

  trackHistoryData(data) {
    this.displayPlay = false;
    this.displayPause = true;
    this.displayStop = true;
    this.liveCount = 0;
    this.statusVehicle = false;
    this.trackHistoryJson = data.routeGeometry;
    let trackHistoryArray = [];
    let timeStamp = [];
    let maxSpeed = [];
    let odometer = [];
    let status = [];
    this.trackHistoryJson.forEach(function (
      value) {
      if (value.latitude !== 0 && value.longitude !== 0) {
        trackHistoryArray.push({
          lat: value.latitude,
          lng: value.longitude
        });
      }
      if (value.timeStamp) {
        timeStamp.push(
          `${value.timeStamp.split(" ")[1]} ${value.timeStamp.split(" ")[2]}`
        )
      }
      if (value.speed || value.speed == 0) {
        maxSpeed.push(
          value.speed
        )
      }
      if (value.odometer || value.odometer == 0) {
        odometer.push(
          parseFloat(value.odometer)
        )
      }
      if (value.vehicleStatus == "Towed") {
        status.push(value.vehicleStatus)
      }
    });
    if (status.includes('Towed')) {
      this.statusVehicle = true;
    }
    this.stopTrackHistoryArray = trackHistoryArray;
    this.timeStampArray = timeStamp;
    this.maxSpeed = maxSpeed;
    this.odometerArray = odometer;
    this.plotBackTrackingPath(trackHistoryArray, true);
  }









  plotBackTrackingPath(finalpath, check) {
    if (finalpath.length === 0) {
      if (this.type == "Multi Track")
        this.commonService.presentAlert("No data", this.trans.instant("Data not available") + this.trans.instant(" For ") + this.splitNameArabic(this.trans.instant(this.selectedVin.plateNo)));
      else
        this.commonService.presentAlert("No data", "Data not available");

      this.mapService.clearLayers(this.map, [1, 2]);
      this.commonService.dismissLoader();
    } else {
      this.stopColor()
      this.checkingPlotMarkers(['stop', 'idle', 'Speed']);
      this.commonService.dismissLoader();

    }
  }

  checkingPlotMarkers(data) {
    for (let cnt = 0; cnt < data.length; cnt++) {
      this.plotMarkers(data[cnt]);
    }
    return;
  }



  plotMarkers(mode) {
    let end = 2;
    if (this.trackHistoryJson.length == 1) {
      end = 1
    }
    for (let cnt = 0; cnt < end; cnt++) {
      this.populateMarker(this.trackHistoryJson, cnt, mode);
      this.plotChangeMarker();
    }
  }

  plotChangeMarker() {
    let json = this.trackHistoryJson;
    var cnt: number;
    let markerNumber = 1;
    if (this.entrypoint == "ATM")
      cnt = 0
    else
      cnt = 1
    for (cnt; cnt < this.trackHistoryJson.length - 1; cnt++) {
      let source = {
        lat: parseFloat(json[cnt]['latitude']),
        lng: parseFloat(json[cnt]['longitude'])
      };
      let icon = 'assets/trackHistoryIcons/oldblue.png';

      const diffMin = this.commonService.secondstoHHMMSSCal(
        new Date(json[cnt + 1]['timeStamp']), new Date(json[cnt]['timeStamp']));
      if (json[cnt]['vehicleStatus'] == "Stop" && this.showdataMarker.stop == true) {
        icon = 'assets/trackHistoryIcons/oldred.png';
        json[cnt]["duration"] = diffMin;
        this.mapService.addMarkerWithInfoWindow(this.map, source, json[cnt], icon, markerNumber.toString());
        markerNumber++;

      } else if (json[cnt]['vehicleStatus'] == "Out_Of_Zone" && this.showdataMarker.outofzone == true) {
        icon = 'assets/trackHistoryIcons/oldred.png';
        json[cnt]["duration"] = diffMin;
        this.mapService.addMarkerWithInfoWindow(this.map, source, json[cnt], icon, markerNumber.toString());
        markerNumber++;

      } else if (json[cnt]['vehicleStatus'] == "Idle" && this.showdataMarker.idle == true) {
        icon = 'assets/trackHistoryIcons/oldblue.png';
        json[cnt]["duration"] = diffMin;
        this.mapService.addMarkerWithInfoWindow(this.map, source, json[cnt], icon, markerNumber.toString());
        markerNumber++;

      } else if (json[cnt]['vehicleStatus'] == "Overspeed" && this.showdataMarker.overSpeed == true) {
        icon = 'assets/trackHistoryIcons/oldorange.png';

        this.mapService.addMarkerWithInfoWindow(this.map, source, json[cnt], icon, markerNumber.toString());
        markerNumber++;

      } else if (json[cnt]['vehicleStatus'] == "Towed" && this.showdataMarker.towed == true) {
        icon = 'assets/trackHistoryIcons/oldrose.png';
        this.mapService.addMarkerWithInfoWindow(this.map, source, json[cnt], icon, markerNumber.toString());
        markerNumber++;

      } else if (json[cnt]['vehicleStatus'] == "Running" && this.showdataMarker.running == true) {
        icon = 'assets/trackHistoryIcons/oldgreen.png';
        const statusForHistory = this.commonService
          .liveTrackingStatus(this.selectedVin.vin, "Running");
        json[cnt]['vehicleStatus'] = statusForHistory;

        this.mapService.addMarkerWithInfoWindow(this.map, source, json[cnt], icon, markerNumber.toString());
        markerNumber++;

      } else if (json[cnt]['vehicleStatus'] == "Working" && this.showdataMarker.working == true) {
        icon = 'assets/trackHistoryIcons/oldgreen.png';
        const statusForHistory = this.commonService
          .liveTrackingStatus(this.selectedVin.vin, "Working");
        json[cnt]['vehicleStatus'] = statusForHistory;

        this.mapService.addMarkerWithInfoWindow(this.map, source, json[cnt], icon, markerNumber.toString());
        markerNumber++;

      } else if (json[cnt]['vehicleStatus'] == "Movement" && this.showdataMarker.movement == true) {
        icon = 'assets/trackHistoryIcons/oldgreen.png';
        const statusForHistory = this.commonService
          .liveTrackingStatus(this.selectedVin.vin, "Movement");
        json[cnt]['vehicleStatus'] = statusForHistory;

        this.mapService.addMarkerWithInfoWindow(this.map, source, json[cnt], icon, markerNumber.toString());
        markerNumber++;

      }
      else if (json[cnt]['vehicleStatus'] == "OnLine" && this.showdataMarker.poweron == true) {
        icon = 'assets/trackHistoryIcons/oldblue.png';
        const statusForHistory = this.commonService
          .liveTrackingStatus(this.selectedVin.vin, "OnLine");
        json[cnt]['vehicleStatus'] = statusForHistory;

        this.mapService.addMarkerWithInfoWindow(this.map, source, json[cnt], icon, markerNumber.toString());
        markerNumber++;

      } else if (json[cnt]['vehicleStatus'] == "PowerCut" && this.showdataMarker.powercut == true) {
        icon = 'assets/trackHistoryIcons/oldred.png';
        const statusForHistory = this.commonService
          .liveTrackingStatus(this.selectedVin.vin, "PowerCut");
        json[cnt]['vehicleStatus'] = statusForHistory;

        this.mapService.addMarkerWithInfoWindow(this.map, source, json[cnt], icon, markerNumber.toString());
        markerNumber++;

      } else if (json[cnt]['vehicleStatus'] == "LowBattery" && this.showdataMarker.lowbattery == true) {
        icon = 'assets/trackHistoryIcons/oldorange.png';
        const statusForHistory = this.commonService
          .liveTrackingStatus(this.selectedVin.vin, "LowBattery");
        json[cnt]['vehicleStatus'] = statusForHistory;

        this.mapService.addMarkerWithInfoWindow(this.map, source, json[cnt], icon, markerNumber.toString());
        markerNumber++;

      } else if (json[cnt]['vehicleStatus'] == "BatteryDrain" && this.showdataMarker.BatteryDrain == true) {
        icon = 'assets/trackHistoryIcons/oldskyblue.png';
        const statusForHistory = this.commonService
          .liveTrackingStatus(this.selectedVin.vin, "BatteryDrain");
        json[cnt]['vehicleStatus'] = statusForHistory;

        this.mapService.addMarkerWithInfoWindow(this.map, source, json[cnt], icon, markerNumber.toString());
        markerNumber++;

      }

    }
    this.mapService.fitBounds(this.map, 2);
    this.map.on('pointermove', (e) => {
      const pixel = this.map.getEventPixel(e.originalEvent);
      const hit = this.map.hasFeatureAtPixel(pixel);
      document.getElementById('map').style.cursor = hit ? 'pointer' : '';
    });
  }
  populateMarker(json, cnt, mode) {
    let source = {
      lat: parseFloat(json[cnt]['latitude']),
      lng: parseFloat(json[cnt]['longitude'])
    };
    const currSpeed = parseInt(json[cnt]['speed']);
    if (cnt === 0) {
      // const starticon = 'assets/vtstrackhisIcon/startFlag.png';
      const starticon = this.trackHistoryJson.length == 1 ? 'assets/vtstrackhisIcon/endFlag.png' : 'assets/vtstrackhisIcon/startFlag.png';
      this.createMarkerforStopIdle(source, starticon, '', 'Beginning of Trip', json[cnt]['timeStamp'], currSpeed, json[cnt]['address'], json[cnt]['fuelLtr']);
    }
    if (cnt == 1) {
      cnt = this.trackHistoryJson.length - 1;
      source = {
        lat: parseFloat(json[cnt]['latitude']),
        lng: parseFloat(json[cnt]['longitude'])
      };
      const endicon = 'assets/vtstrackhisIcon/endFlag.png';
      this.createMarkerforStopIdle(source, endicon, '', 'End of Trip', json[cnt]['timeStamp'], currSpeed, json[cnt]['address'], json[cnt]['fuelLtr']);
      this.mapService.fitBounds(this.map, 1);
    }
    // if( this.showdataMarker.powercut){
    //   const endicon = 'assets/trackHistoryIcons/oldred.png';
    //   this.createMarkerforStopIdle(source, endicon, '',
    //   'End of Trip', json[cnt]['timeStamp'],
    //   currSpeed);
    // }
    this.map.on('pointermove', (e) => {
      const pixel = this.map.getEventPixel(e.originalEvent);
      const hit = this.map.hasFeatureAtPixel(pixel);
      document.getElementById('map').style.cursor = hit ? 'pointer' : '';
    });

  }

  createMarkerforStopIdle(source, icon, diffrenceinMin, status, time, speed, addrs,fuelLtr) {
    let min = '', speedCheck = '';
    let contentString: object = {};
    contentString["status"] = status;
    if (status === 'Stop') {
      contentString["duration"] = diffrenceinMin;
    } else if (status === 'Idle') {
      contentString["duration"] = diffrenceinMin;
    } else {
      contentString["speed"] = speed;
    }
    contentString["latlng"] = source;
    contentString["timeStamp"] = time;
    contentString["address"] = addrs;
    contentString["fuelLtr"] = fuelLtr;
    const dateTime = time.split(' ')[0] + ' ' + time.split(' ')[1];
    const amPm = time.split(' ')[2];
    this.mapService.addMarkerWithInfoWindow(this.map, source, contentString, icon, "");
  }

  stopMapToDefaultView() {
    this.playbackUpdater.status = false;
    this.trackHistoryData(this.trackHistoryCurrentRes);
  }
  getLiveTrackIcon = (color, path) => {
    if (this.traveVinData.icon == "REFRIGERATOR") {
      var viewbox = "-220 -1000 2471.4 2448.1";
    }
    else if (this.traveVinData.icon == "CRAWLER EXCAVATOR") {
      var viewbox = "-653 -1800 2471.4 2448.1";
    }
    else if (this.traveVinData.icon == "FLATBED TRUCK") {
      var viewbox = "0 0 94 93";
      path = 'M48.233 61.4595C54.8011 61.4595 60.1255 66.7842 60.1255 73.3519C60.1255 79.9204 54.8011 85.2451 48.233 85.2451C41.6649 85.2451 36.3402 79.9204 36.3402 73.3519C36.3402 66.7842 41.6649 61.4595 48.233 61.4595ZM35.2094 72.7707C35.2094 74.6908 35.2463 75.2088 35.7514 77.0427C36.1986 78.665 37.4393 80.8723 38.6171 82.0426C38.7199 82.1442 38.7473 82.1766 38.8448 82.2895C38.9194 82.3757 38.8667 82.3219 38.9393 82.3987L39.0428 82.4984C39.0534 82.5078 39.0688 82.5206 39.0793 82.5297C39.8875 83.2373 39.6767 83.1402 40.6923 83.9002C43.3053 85.8549 44.9763 88.0347 46.5971 90.7434C46.9615 91.3521 47.281 92.0959 48.2285 92.0959C48.8319 92.0959 49.1966 91.7737 49.45 91.4187C49.7146 91.0479 49.9555 90.6045 50.1983 90.201L50.9372 88.9731C51.064 88.7616 51.154 88.6061 51.3079 88.395L52.1507 87.2714C52.7635 86.5204 53.819 85.4006 54.573 84.8111C54.7777 84.6511 54.879 84.5461 55.0958 84.3846C55.3092 84.2258 55.4707 84.1038 55.677 83.9491C57.5594 82.5368 59.1694 80.8271 60.1142 78.6214C61.9706 74.2862 61.5822 69.3886 58.8167 65.6403C58.7034 65.4867 58.619 65.3768 58.4971 65.2142C56.367 62.3723 52.4575 60.2263 48.0248 60.2263C43.253 60.2263 39.1746 63.0212 37.0267 66.5866C36.4109 67.6082 35.9035 68.8293 35.6159 69.9905C35.4074 70.8337 35.2094 71.722 35.2094 72.7707Z M40.5861 71.3858C40.6428 71.3819 40.6996 71.38 40.7565 71.3801L41.9202 71.3813C42.1182 71.3812 42.3207 71.377 42.5181 71.3847C42.7656 71.3943 42.7151 71.7463 42.7146 71.9196L42.7137 72.4732C42.7188 73.0212 42.7199 73.5692 42.717 74.1173C42.7152 74.2441 42.7334 74.3825 42.5686 74.3902C42.4388 74.3963 42.3076 74.392 42.1776 74.3913L41.3575 74.3877C41.2327 74.3872 41.0096 74.3752 40.9045 74.4217C40.7522 74.489 40.7952 74.9676 40.7959 75.114C40.6873 75.1158 40.5787 75.1167 40.4701 75.1169C40.45 74.8566 40.3806 74.6369 40.2048 74.4379C39.871 74.1124 39.4446 73.9798 39.0126 74.2147C38.9168 74.2603 38.8156 74.3582 38.7093 74.3754C38.4395 74.4191 38.1481 74.3687 37.8784 74.3907C37.8791 74.1636 37.8485 73.3645 37.9582 73.1971C37.9962 73.1392 38.0571 73.0843 38.1224 73.0593C38.3035 72.99 38.8067 72.9425 39.0218 72.9169C39.2053 72.8951 39.3869 72.8594 39.5699 72.833C39.7297 72.81 39.8922 72.797 40.0504 72.7649C40.1526 72.6273 40.4346 71.9215 40.4995 71.7428C40.3862 71.7394 40.154 71.7583 40.2915 71.5743C40.3702 71.469 40.4571 71.4035 40.5861 71.3858ZM41.0587 72.7673C41.1525 72.7673 41.7222 72.7765 41.766 72.7434C41.8319 72.6936 41.8288 71.8718 41.7944 71.8175C41.7049 71.7569 41.2736 71.7711 41.1452 71.7735C41.0571 71.7754 40.8292 71.7678 40.7876 71.8283C40.6912 71.9681 40.4406 72.5692 40.4077 72.7142C40.4735 72.7896 40.941 72.7671 41.0587 72.7673ZM42.357 72.7517C42.4008 72.7405 42.4005 72.748 42.4261 72.7184C42.4509 72.5659 42.4332 71.9587 42.4157 71.8C42.2996 71.7716 42.223 71.7765 42.1059 71.7814C42.0678 71.806 42.0496 71.8108 42.0398 71.863C42.0124 72.0099 42.0078 72.5953 42.047 72.7158C42.1019 72.7889 42.2771 72.7643 42.357 72.7517ZM41.7867 73.1594C41.8 73.1208 41.8032 73.1128 41.8014 73.0725C41.7499 73.0029 41.4922 73.0315 41.4017 73.0358C41.3946 73.0709 41.3915 73.0802 41.4006 73.1142C41.4571 73.1972 41.6915 73.1693 41.7867 73.1594Z M44.271 73.6046C44.3824 73.5988 44.5337 73.605 44.6476 73.6058L45.3089 73.6074L58.3359 73.6081C58.4397 73.6082 58.6743 73.5854 58.7581 73.6359C58.8162 73.6708 58.8221 73.8642 58.7748 73.9151C58.7391 73.9536 58.6353 73.9469 58.5828 73.9478C58.1448 73.9575 57.6933 73.952 57.2546 73.9519L45.1377 73.9481C44.8635 73.946 44.2754 73.9736 44.0382 73.9152C44.0306 73.6582 44.0007 73.6184 44.271 73.6046Z M43.3427 70.8135L43.3729 70.8147C43.4088 70.8661 43.3877 70.9943 43.3826 71.0635C43.3083 71.1136 43.2886 71.1332 43.2369 71.2067C43.2102 71.4034 43.2205 71.6613 43.2241 71.8631L43.3532 71.8833C43.3768 72.1293 43.3661 72.4795 43.3658 72.7338C43.3694 73.1587 43.3672 73.5836 43.3592 74.0083L43.2253 74.0296C43.2241 74.1201 43.224 74.2106 43.225 74.3011C43.5883 74.3171 44.0228 74.3009 44.399 74.3074C44.0905 74.5845 44.0462 74.7182 43.9802 75.1105C43.8386 75.1234 43.6376 75.12 43.4919 75.1203L42.7268 75.1198C42.6895 75.4714 42.4779 75.3671 42.1774 75.371C41.9953 75.3727 41.0781 75.3866 40.9677 75.344C40.941 75.322 40.9324 75.2987 40.9273 75.2648C40.9098 75.1482 40.8914 74.6267 40.9472 74.5542C41.0129 74.4689 42.4726 74.5361 42.7091 74.5015C42.7682 74.4433 42.8141 74.3858 42.8554 74.314L42.9576 74.293C42.9595 74.2044 42.9597 74.1158 42.9582 74.0272L42.841 74.0024C42.8366 73.7635 42.8234 71.993 42.8547 71.9081C42.8789 71.8779 42.9203 71.8681 42.9576 71.8548C42.9589 71.7465 42.9608 71.6247 42.9593 71.5166C42.954 71.1245 42.9876 70.986 43.3427 70.8135Z M48.432 74.087C48.8746 74.0759 49.3295 74.0799 49.773 74.0798L58.3396 74.0812C58.3404 74.2272 58.3452 74.3811 58.3245 74.5251C58.233 74.5352 58.1412 74.543 58.0492 74.5484C58.1158 74.8072 58.1505 74.8075 58.1586 75.1112C58.0868 75.1157 58.0127 75.1174 57.9406 75.1201C57.9288 74.9877 57.8994 74.8529 57.8458 74.7309C57.7417 74.4959 57.5489 74.3116 57.3096 74.2183C56.9724 74.1011 56.6698 74.1373 56.3804 74.3576C56.1293 74.5489 56.0399 74.8076 56.0011 75.1088C55.9691 75.1123 55.934 75.118 55.9018 75.1226C55.8667 74.9148 55.8307 74.7364 55.7043 74.5603C55.3984 74.1346 54.8023 74.014 54.3736 74.3303C54.101 74.5313 53.9989 74.799 53.9454 75.1173C53.8622 75.1194 53.8036 75.1142 53.7213 75.1069C53.7216 74.8882 53.781 74.7476 53.8428 74.544C53.4711 74.5248 52.965 74.5391 52.5859 74.5386L50.1377 74.5385L49.3991 74.5414C49.289 74.5418 48.9278 74.5638 48.8523 74.4964C48.7955 74.4455 48.4399 74.1349 48.432 74.087Z M54.8301 74.2956C55.2817 74.2425 55.6906 74.5666 55.742 75.0186C55.7935 75.4707 55.4679 75.8785 55.0158 75.9283C54.5661 75.9778 54.161 75.6542 54.1098 75.2045C54.0586 74.7548 54.3807 74.3484 54.8301 74.2956ZM55.0165 75.4974C55.2263 75.4466 55.3565 75.2366 55.3087 75.0259C55.2609 74.8153 55.0527 74.6821 54.8415 74.727C54.7022 74.7565 54.5896 74.8589 54.5469 74.9948C54.5041 75.1306 54.5378 75.279 54.635 75.3831C54.7323 75.4872 54.878 75.5309 55.0165 75.4974Z M46.832 74.3068C47.278 74.2221 47.7079 74.5161 47.7909 74.9626C47.8739 75.4091 47.5785 75.8381 47.1318 75.9195C46.6875 76.0005 46.2613 75.7068 46.1788 75.2626C46.0962 74.8184 46.3882 74.391 46.832 74.3068ZM47.0717 75.4983C47.2835 75.4514 47.4176 75.2422 47.3719 75.0301C47.3262 74.818 47.1178 74.6827 46.9055 74.7273C46.6917 74.7722 46.5551 74.9827 46.6012 75.1964C46.6473 75.4101 46.8584 75.5455 47.0717 75.4983Z M56.8786 74.2948C57.3302 74.245 57.7364 74.5722 57.7838 75.0243C57.8313 75.4764 57.5021 75.8809 57.0499 75.9261C56.6011 75.9709 56.2003 75.6446 56.1532 75.1958C56.1059 74.7469 56.4301 74.3443 56.8786 74.2948ZM57.0495 75.5013C57.2631 75.4557 57.3995 75.2457 57.3543 75.0319C57.3092 74.8182 57.0996 74.6813 56.8858 74.726C56.6714 74.7708 56.5341 74.9813 56.5793 75.1957C56.6246 75.4101 56.8353 75.547 57.0495 75.5013Z M44.9032 74.2931C45.3553 74.2702 45.7403 74.6184 45.7628 75.0707C45.7853 75.523 45.4369 75.9078 44.9848 75.93C44.5332 75.9521 44.149 75.604 44.1265 75.1523C44.104 74.7005 44.4516 74.3159 44.9032 74.2931ZM45.0277 75.4996C45.2406 75.4532 45.3758 75.2433 45.3301 75.0302C45.2843 74.8171 45.0748 74.6812 44.8617 74.7264C44.6477 74.7718 44.5113 74.9823 44.5572 75.1962C44.6031 75.4102 44.814 75.5461 45.0277 75.4996Z M39.3851 74.2963C39.8334 74.254 40.2315 74.5822 40.2759 75.0304C40.3203 75.4787 39.9943 75.8785 39.5464 75.9251C39.0954 75.9721 38.6923 75.6432 38.6476 75.1918C38.6029 74.7404 38.9337 74.3388 39.3851 74.2963ZM39.5456 75.4972C39.7577 75.4501 39.8917 75.2402 39.8452 75.0279C39.7986 74.8157 39.5891 74.6811 39.3768 74.7272C39.1638 74.7734 39.0287 74.9839 39.0754 75.1968C39.1221 75.4098 39.3328 75.5444 39.5456 75.4972Z M37.881 74.5148C38.0506 74.4989 38.448 74.5148 38.6339 74.5179C38.571 74.6357 38.5344 74.7123 38.4944 74.838C38.4671 74.9237 38.4618 75.1913 38.4119 75.2347C38.1808 75.246 37.8814 75.2868 37.6841 75.1775L37.6806 75.1469C37.6679 75.0281 37.6311 74.6745 37.7003 74.5668C37.7305 74.5197 37.8271 74.5182 37.881 74.5148Z M45.3059 74.0863C45.7319 74.0691 46.1785 74.0818 46.6058 74.0839C46.6517 74.0841 46.6893 74.1223 46.6828 74.1697C46.6443 74.2133 46.5504 74.2034 46.4952 74.2136C46.4655 74.2154 46.4911 74.2848 46.4668 74.3043C46.3286 74.4153 46.237 74.5005 46.1474 74.6546C46.0612 74.7613 46.0537 75.0174 46 75.1006C45.9762 75.1112 45.9172 75.1167 45.9079 75.09C45.8695 74.9795 45.8754 74.8607 45.8322 74.7496C45.7584 74.5595 45.6177 74.4291 45.4643 74.3038C45.4498 74.2919 45.4638 74.2484 45.4669 74.2272C45.4037 74.1752 45.3231 74.2292 45.2809 74.1445C45.2855 74.1149 45.2851 74.1074 45.3059 74.0863Z M47.8015 74.3011C47.8752 74.3003 48.1473 74.2812 48.1652 74.3689C48.1947 74.5144 48.2154 74.9467 48.1557 75.074C48.112 75.1179 48.0145 75.1204 47.9518 75.127C47.8959 74.7106 47.8282 74.5872 47.5185 74.304C47.6104 74.3059 47.7091 74.3027 47.8015 74.3011Z'
    } else if (this.traveVinData.icon == "FIRE & RESCUE TRUCK") {
      var viewbox = "0 0 94 93";
      path = "M48.233 61.4595C54.8011 61.4595 60.1255 66.7842 60.1255 73.3519C60.1255 79.9204 54.8011 85.2451 48.233 85.2451C41.6649 85.2451 36.3402 79.9204 36.3402 73.3519C36.3402 66.7842 41.6649 61.4595 48.233 61.4595ZM35.2094 72.7707C35.2094 74.6908 35.2463 75.2088 35.7514 77.0427C36.1986 78.665 37.4393 80.8723 38.6171 82.0426C38.7199 82.1442 38.7473 82.1766 38.8448 82.2895C38.9194 82.3757 38.8667 82.3219 38.9393 82.3987L39.0428 82.4984C39.0534 82.5078 39.0688 82.5206 39.0793 82.5297C39.8875 83.2373 39.6767 83.1402 40.6923 83.9002C43.3053 85.8549 44.9763 88.0347 46.5971 90.7434C46.9615 91.3521 47.281 92.0959 48.2285 92.0959C48.8319 92.0959 49.1966 91.7737 49.45 91.4187C49.7146 91.0479 49.9555 90.6045 50.1983 90.201L50.9372 88.9731C51.064 88.7616 51.154 88.6061 51.3079 88.395L52.1507 87.2714C52.7635 86.5204 53.819 85.4006 54.573 84.8111C54.7777 84.6511 54.879 84.5461 55.0958 84.3846C55.3092 84.2258 55.4707 84.1038 55.677 83.9491C57.5594 82.5368 59.1694 80.8271 60.1142 78.6214C61.9706 74.2862 61.5822 69.3886 58.8167 65.6403C58.7034 65.4867 58.619 65.3768 58.4971 65.2142C56.367 62.3723 52.4575 60.2263 48.0248 60.2263C43.253 60.2263 39.1746 63.0212 37.0267 66.5866C36.4109 67.6082 35.9035 68.8293 35.6159 69.9905C35.4074 70.8337 35.2094 71.722 35.2094 72.7707Z M46.5921 70.9809L58.1662 70.9816L58.165 76.2044L58.2179 76.2029C58.4333 76.1969 58.5011 76.1824 58.6608 76.3334C58.6744 76.3851 58.6916 76.4467 58.6909 76.4947C58.6865 76.7557 58.7832 77.1665 58.3991 77.1786C58.1794 77.1855 57.9411 77.1821 57.7211 77.1825L56.2376 77.1828C56.2334 77.1767 56.2292 77.1707 56.225 77.1645C56.2378 77.02 56.2395 76.8614 56.2262 76.7203C56.1695 76.1685 55.8946 75.6622 55.4626 75.3142C55.0514 74.9714 54.5189 74.8098 53.9866 74.8664C52.8311 74.9863 52.0474 76.0459 52.1665 77.185C51.5442 77.1761 50.9038 77.1833 50.2805 77.1833L46.5944 77.1827C46.6058 76.8215 46.5967 76.4129 46.5969 76.0492L46.5981 72.0813C46.598 71.7246 46.6056 71.3347 46.5921 70.9809ZM47.6653 71.7806C47.625 71.8083 47.5766 71.8359 47.5751 71.8862C47.5716 72.0052 47.5724 72.1363 47.5723 72.2544L47.5723 73.1658L47.5672 75.4462C47.5669 75.6778 47.5501 76.386 47.5962 76.5824C47.6665 76.652 48.7167 76.6259 48.9061 76.6259H51.0411C51.0991 76.6255 51.1462 76.6278 51.2018 76.6074C51.2295 76.5726 51.2529 76.5459 51.2542 76.5004C51.2614 76.2286 51.2546 75.9514 51.256 75.6793L51.2564 72.4521C51.2567 72.2865 51.2573 72.1208 51.2551 71.9552C51.2543 71.887 51.2462 71.8477 51.1967 71.7987C51.071 71.7697 50.8222 71.7781 50.6837 71.7781L48.4555 71.7787C48.2002 71.7789 47.9182 71.7729 47.6653 71.7806ZM53.9096 73.1551C53.8164 73.0035 53.8227 72.9396 53.8091 72.7616C53.567 73.0283 53.383 73.3798 53.4007 73.7485C53.4132 74.0042 53.5287 74.244 53.7209 74.4131C53.9056 74.5777 54.087 74.6409 54.321 74.6981C54.1483 74.5797 54.0413 74.4746 53.9896 74.2576C53.9624 74.1429 53.9943 73.8249 54.1109 73.769C54.1537 73.789 54.2022 73.9083 54.2291 73.9567C54.2297 73.7183 54.2987 73.7267 54.3895 73.5251C54.4449 73.402 54.3412 73.3125 54.5094 73.2037L54.5229 73.2109L54.5239 73.2345C54.5329 73.4369 54.6073 73.4411 54.6836 73.6297L54.6869 73.6437C54.7005 73.705 54.7031 73.7247 54.7009 73.7868C54.6981 73.8684 54.6199 73.9628 54.6666 74.0265C54.7986 74.0451 54.8406 73.8829 54.8707 73.7884C55.1566 74.122 55.0199 74.4763 54.6766 74.6928C54.8193 74.6611 54.9519 74.6354 55.0799 74.5613C55.8021 74.1432 55.7177 73.3617 55.2621 72.7871C55.2674 72.9574 55.2818 73.1528 55.16 73.2888C55.1055 73.3498 55.0389 73.3985 54.9639 73.3458C54.886 73.2002 55.0027 73.0846 55.0141 72.9446C55.0596 72.3842 54.6827 71.95 54.213 71.7102C54.3382 71.9684 54.33 72.2357 54.2392 72.5033C54.1563 72.7476 54.0081 72.9257 53.9096 73.1551Z M47.7482 71.9754C48.8494 71.9754 49.9699 71.9867 51.0695 71.9736C51.0793 72.9508 51.0545 75.3125 51.0685 76.412C51.0626 76.4179 51.0568 76.4239 51.0509 76.43L51.0049 76.4287L47.7562 76.4335L47.7513 73.3964C47.7515 72.9457 47.7674 72.4167 47.7482 71.9754ZM50.659 74.9686C50.7933 74.8861 50.7401 74.7553 50.6065 74.7524C50.3362 74.7462 50.0644 74.7504 49.7939 74.7506L48.1562 74.7532C48.0929 74.8058 48.0684 74.8472 48.1056 74.9274C48.1316 74.9483 48.1514 74.9619 48.1861 74.9638C48.3926 74.9753 48.6152 74.9707 48.8222 74.9707L50.0516 74.9694C50.2419 74.9691 50.4751 74.9583 50.659 74.9686ZM49.0164 75.8823C48.9561 75.919 48.9151 75.9609 48.9408 76.0368C48.9835 76.0847 49.0521 76.1006 49.1137 76.1008C49.3525 76.1017 49.594 76.1001 49.8326 76.0993C49.9857 75.9989 49.8811 75.8879 49.7537 75.8842C49.5224 75.8773 49.2727 75.8776 49.0418 75.8814C49.0333 75.8815 49.0249 75.8819 49.0164 75.8823ZM50.6686 73.8173C50.7273 73.7715 50.7581 73.7294 50.717 73.6536C50.6589 73.6028 50.5361 73.6087 50.46 73.61C49.694 73.624 48.9139 73.59 48.1491 73.6103C48.1138 73.6442 48.0881 73.6742 48.0886 73.7274C48.0888 73.754 48.1007 73.7791 48.1213 73.7959C48.1744 73.839 48.5447 73.8199 48.6384 73.8193L49.3649 73.8185C49.7478 73.8186 50.2953 73.8363 50.6686 73.8173ZM48.134 74.1848C48.1058 74.2262 48.0802 74.2679 48.0915 74.32C48.0967 74.3441 48.1119 74.3671 48.1354 74.3775C48.1974 74.405 50.5021 74.4087 50.677 74.3892C50.7299 74.3382 50.7595 74.2816 50.71 74.2131C50.6401 74.1609 50.3207 74.1801 50.2171 74.1803L49.4375 74.1814L48.5976 74.1813C48.4599 74.1812 48.268 74.1758 48.134 74.1848ZM48.1668 72.467C48.1238 72.4936 48.0998 72.514 48.0904 72.5662C48.0628 72.7175 48.3728 72.6788 48.4635 72.6789L50.086 72.6795C50.2104 72.6794 50.6143 72.6916 50.7051 72.6588C50.7332 72.6073 50.7573 72.4854 50.6759 72.4818C49.8434 72.445 49.0015 72.4869 48.1668 72.467ZM50.678 75.5332C50.769 75.4444 50.7606 75.3335 50.6149 75.3311C50.0072 75.3214 49.3984 75.3284 48.7904 75.3271C48.5763 75.3266 48.3525 75.322 48.1394 75.3316C48.1036 75.3691 48.0869 75.3884 48.0893 75.4439C48.0924 75.5214 48.162 75.5372 48.2227 75.5374C48.7392 75.5395 49.2558 75.5386 49.7723 75.5385L50.3553 75.5383C50.4279 75.5383 50.6111 75.5415 50.678 75.5332ZM48.1357 73.0433C48.1083 73.0822 48.0824 73.1239 48.0907 73.1741C48.0944 73.1964 48.1137 73.2254 48.1348 73.2346C48.196 73.2612 50.5805 73.2695 50.683 73.2416C50.7767 73.1461 50.7484 73.0442 50.6095 73.0399C50.4627 73.0353 50.316 73.037 50.1691 73.037L48.5824 73.0375C48.4512 73.0376 48.261 73.0325 48.1357 73.0433Z M40 69.4079C40.0223 69.4069 40.0446 69.4061 40.0669 69.4054C40.4657 69.3933 40.9233 69.4041 41.3266 69.4041L45.2152 69.4042C45.4682 69.4038 45.7335 69.3984 45.9862 69.4096C46.0923 69.4202 46.1981 69.4808 46.2732 69.551C46.4441 69.7109 46.41 69.9372 46.4147 70.1485C46.4177 70.282 46.4156 70.4207 46.4157 70.5559L46.4126 72.0636L46.4144 77.1854L44.4298 77.1823C44.4777 76.6145 44.3674 76.1342 44.0175 75.6744C43.6585 75.2025 43.1843 74.9401 42.6007 74.8627C42.4806 74.8563 42.3684 74.8522 42.2481 74.8608C41.2319 74.9345 40.3964 75.8169 40.3623 76.8324C40.3581 76.9555 40.3629 77.0598 40.372 77.1821L38.7137 77.182C38.4608 77.1815 38.2034 77.1859 37.9506 77.1827C37.5289 77.1707 37.6617 76.8107 37.6309 76.5549C37.5553 75.9264 38.0176 76.0518 38.4925 76.0528L39.3543 76.0525C39.4548 76.053 39.6855 76.0857 39.7243 75.9791C39.7156 75.9348 39.7098 75.9319 39.6848 75.8953C39.622 75.8519 39.204 75.8718 39.0976 75.8718L37.9818 75.8699C37.9709 75.5847 37.9831 75.2751 37.9779 74.9868C37.9805 74.7832 37.9709 74.579 37.9834 74.3758C37.9944 74.1969 38.099 74.1379 38.261 74.1088C38.266 73.8419 38.2425 73.4099 38.2895 73.1641C38.3146 73.033 38.4882 72.6194 38.545 72.4763L39.0183 71.2751L39.4538 70.1577C39.5196 69.9879 39.5982 69.766 39.6795 69.604C39.7317 69.4999 39.887 69.4355 40 69.4079ZM42.7206 72.5005C42.7717 72.4614 42.789 72.4503 42.8302 72.4025C42.8474 72.2804 42.8418 72.1118 42.8419 71.9857L42.843 70.6077C42.8431 70.4849 42.8451 70.3613 42.8411 70.2387C42.8384 70.1557 42.7847 70.1143 42.7224 70.0719C42.4828 70.0529 42.1207 70.0628 41.8741 70.063L40.3539 70.0628C40.2695 70.071 40.1996 70.0842 40.1411 70.1503C40.1064 70.1896 39.0589 72.8328 38.9896 73.0416C38.9794 73.0723 38.9748 73.1018 38.9789 73.134C38.984 73.1736 39.0024 73.2066 39.0362 73.2288C39.0753 73.2545 39.1234 73.2641 39.1691 73.2696C39.3022 73.2856 40.0736 73.278 40.1802 73.2518C40.4012 73.1974 40.7158 72.8212 40.8895 72.6565C41.1292 72.4563 41.3576 72.5133 41.6472 72.5056C42.0017 72.496 42.3671 72.5201 42.7206 72.5005ZM45.6238 72.5037C45.6744 72.487 45.7394 72.4556 45.7609 72.4022C45.7943 72.3197 45.7917 70.4491 45.7788 70.2402C45.7773 70.2157 45.7735 70.1909 45.7625 70.1687C45.7417 70.1268 45.6987 70.0979 45.6608 70.073C45.4823 70.054 45.1552 70.0627 44.9629 70.0629L43.7054 70.063C43.5914 70.0689 43.4825 70.0856 43.4743 70.2254C43.4645 70.3937 43.4673 70.563 43.4673 70.7316L43.4676 71.592C43.4674 71.8421 43.4625 72.1315 43.4743 72.3816C43.4764 72.4258 43.5444 72.4751 43.5816 72.4998C43.7952 72.5162 44.1008 72.5073 44.3197 72.5069L45.6238 72.5037ZM39.2696 75.4804C39.3248 75.4419 39.3525 75.4159 39.3628 75.3475C39.3726 75.2828 39.3726 74.8537 39.3647 74.7802C39.3612 74.7478 39.3567 74.7111 39.3331 74.6864C39.237 74.5856 38.6126 74.6245 38.4592 74.6297C38.3033 74.746 38.3696 74.864 38.3616 75.0317C38.3573 75.1229 38.341 75.3924 38.3918 75.4331C38.4999 75.5197 39.1566 75.4905 39.2696 75.4804ZM45.1733 73.6199C45.3652 73.4891 45.2786 73.302 45.0895 73.3022C44.8174 73.3022 44.5338 73.2938 44.2627 73.3049C44.0462 73.4488 44.148 73.6172 44.3774 73.6212C44.6425 73.626 44.9082 73.6179 45.1733 73.6199Z M46.0952 66.7298C46.2066 66.7224 46.3901 66.7669 46.5054 66.7885L55.6824 68.5255L57.1962 68.8059C57.3815 68.8407 57.5781 68.8714 57.7588 68.9127C57.8794 68.9404 57.9547 69.1813 57.8168 69.2587C57.6749 69.3383 57.5142 69.2822 57.3701 69.2493C57.3319 69.4283 57.3003 69.6777 57.2728 69.8624C57.751 69.8452 57.6965 70.1964 57.6994 70.5429C57.8624 70.5767 57.8464 70.6494 57.8463 70.7895L57.2337 70.7886C56.8434 70.7861 56.4528 70.7921 56.0624 70.7857C56.0664 70.3961 56.2395 70.7314 56.2317 70.3572C55.4377 70.1939 54.5879 70.0554 53.7862 69.9066L46.8187 68.6122C46.5205 68.5565 46.2205 68.5017 45.9223 68.4458C45.6354 68.392 45.7028 68.0215 45.9572 68.0401C46.1134 68.0516 46.2942 68.0938 46.4505 68.1248C46.4641 67.9351 46.5641 67.4354 46.6001 67.2265C46.4554 67.2049 46.0514 67.181 45.9743 67.0334C45.9098 66.91 45.9781 66.7953 46.0952 66.7298ZM48.4092 68.4814C48.7415 68.5507 49.1571 68.6024 49.4722 68.6784C49.5012 68.418 49.5752 68.0699 49.621 67.8037C49.2835 67.7412 48.89 67.6788 48.5578 67.6068C48.5124 67.8796 48.4648 68.2148 48.4092 68.4814ZM51.4275 69.0558C51.7079 69.0786 52.1827 69.1929 52.4801 69.2396C52.5299 68.9586 52.5722 68.6425 52.6299 68.3679C52.4046 68.3297 52.1796 68.2891 51.9552 68.2461C51.8464 68.2259 51.6732 68.1991 51.5716 68.1734C51.5477 68.3983 51.4782 68.8278 51.4275 69.0558ZM49.9242 68.7699C50.1159 68.793 50.3174 68.8354 50.5083 68.8703C50.6544 68.897 50.831 68.9233 50.9742 68.958C51.0129 68.7417 51.0785 68.2826 51.1264 68.0919C50.8067 68.031 50.375 67.9652 50.0714 67.8911C50.0255 68.1845 49.9764 68.4775 49.9242 68.7699ZM46.9048 68.2058C47.2266 68.2582 47.6463 68.3284 47.9621 68.3997C47.9728 68.2661 48.0684 67.6631 48.1046 67.5173C47.7606 67.4524 47.3912 67.3931 47.0524 67.3221C47.014 67.5553 46.928 67.982 46.9048 68.2058ZM56.0663 69.0199C56.0491 69.2063 55.9673 69.6944 55.9228 69.8827C56.0506 69.9057 56.2297 69.9426 56.3548 69.9566C56.5104 69.8431 56.5719 69.8583 56.7668 69.8606C56.8108 69.8608 56.8241 69.8673 56.8587 69.8479C56.9091 69.6455 56.9284 69.395 56.9752 69.1825C56.694 69.1335 56.3394 69.0561 56.0663 69.0199ZM54.5814 68.7438C54.5457 68.9875 54.4855 69.3719 54.4322 69.6104C54.6681 69.6495 54.9032 69.6917 55.138 69.7368C55.1917 69.7467 55.4286 69.7921 55.4734 69.791C55.5266 69.5218 55.5668 69.1892 55.6271 68.9336C55.2779 68.8735 54.9294 68.8103 54.5814 68.7438ZM53.9862 69.5223C54.031 69.2516 54.0778 68.9211 54.1333 68.6556C53.7963 68.5944 53.4054 68.5101 53.0724 68.4644C53.0485 68.7429 52.9727 69.0473 52.9358 69.3275C53.2701 69.3929 53.6506 69.466 53.9862 69.5223Z M54.0502 75.2083C55.0004 75.1298 55.8336 75.8379 55.9096 76.7882C55.9856 77.7386 55.2754 78.57 54.3248 78.6435C53.3777 78.7168 52.55 78.0098 52.4744 77.0628C52.3987 76.1159 53.1035 75.2864 54.0502 75.2083ZM54.3122 77.8806C54.84 77.8139 55.2128 77.3304 55.1431 76.8029C55.0734 76.2754 54.5879 75.9052 54.0607 75.9778C53.5377 76.05 53.1711 76.5309 53.2403 77.0543C53.3094 77.5777 53.7883 77.947 54.3122 77.8806Z M54.1872 76.4379C54.4563 76.4347 54.6772 76.6497 54.6814 76.9187C54.6854 77.1877 54.4712 77.4094 54.2022 77.4144C53.9319 77.4194 53.709 77.2039 53.7048 76.9337C53.7007 76.6634 53.9169 76.4411 54.1872 76.4379Z M42.2669 75.2077C43.2178 75.1349 44.0468 75.8486 44.1164 76.7998C44.186 77.7508 43.4696 78.5775 42.5183 78.6439C41.5714 78.71 40.7494 77.9978 40.6801 77.0511C40.6109 76.1044 41.3204 75.28 42.2669 75.2077ZM42.5302 77.8792C43.0576 77.8048 43.4238 77.3154 43.3462 76.7883C43.2686 76.2614 42.7769 75.8982 42.2503 75.9789C41.7283 76.0592 41.369 76.5457 41.4459 77.0682C41.5228 77.5907 42.0072 77.953 42.5302 77.8792Z M42.2793 76.4503C42.4512 76.4089 42.6322 76.4632 42.7528 76.5927C42.8734 76.7221 42.9149 76.9065 42.8614 77.0751C42.8079 77.2437 42.6677 77.3704 42.4945 77.4065C42.2325 77.4613 41.9749 77.2957 41.9161 77.0345C41.8573 76.7732 42.019 76.5132 42.2793 76.4503Z M47.0229 70.2568C47.7253 70.2764 48.5141 70.2613 49.2193 70.2564L51.1476 70.2605C51.5281 70.2611 51.9096 70.2585 52.2901 70.2565C52.3271 70.2609 52.4315 70.2542 52.4551 70.2874C52.53 70.393 52.5032 70.6571 52.5048 70.7875L52.2823 70.788L46.8897 70.7918C46.8899 70.6657 46.8539 70.3963 46.923 70.2979C46.9456 70.2657 46.986 70.2621 47.0229 70.2568Z M42.0265 67.726C42.0433 67.7243 42.0601 67.7233 42.0769 67.723C42.2767 67.7204 42.4906 67.8117 42.6327 67.9514C42.8825 68.1969 42.8481 68.4726 42.8491 68.7931C42.6317 68.7898 42.4106 68.7913 42.1928 68.7907L41.3305 68.793C41.3272 68.535 41.3044 68.2801 41.4576 68.0589C41.6015 67.8511 41.787 67.7707 42.0265 67.726Z M58.3672 71.8209C58.4791 71.8089 58.5445 71.8111 58.6486 71.8474C58.7151 71.8705 58.8225 71.9832 58.8284 72.0378C58.8474 72.2155 58.8407 72.4441 58.8408 72.6239L58.84 73.9962C58.8389 74.2635 58.8479 74.5307 58.8394 74.7978C58.8339 74.9704 58.7353 75.0697 58.5719 75.109L58.3486 75.1186L58.3496 74.8262C58.4055 74.8243 58.4566 74.8328 58.5003 74.8048C58.5249 74.7681 58.5271 74.7751 58.5266 74.7093C58.5206 73.8575 58.5408 72.9998 58.5193 72.1488C58.5119 72.1411 58.5044 72.1334 58.4969 72.1257C58.4463 72.1051 58.4045 72.11 58.3494 72.11C58.3501 72.0491 58.3405 71.8508 58.3672 71.8209Z M41.1656 68.9788C41.3879 68.9703 42.9585 68.955 43.0462 68.9952C43.0898 69.0151 43.1273 69.0549 43.1433 69.1002C43.1582 69.1423 43.1484 69.1676 43.1304 69.205C43.0893 69.2312 43.0904 69.2215 43.0315 69.221L41.7641 69.2212C41.6619 69.2213 41.083 69.2385 41.0347 69.1958C41.0003 69.1151 41.0929 69.0139 41.1656 68.9788Z M42.048 66.5669C42.0726 66.5649 42.0974 66.566 42.1217 66.5699C42.2513 66.5899 42.2557 66.7709 42.2414 66.8714C42.2147 67.0601 42.3138 67.3159 42.1446 67.4295C42.1192 67.4304 42.0938 67.4296 42.0685 67.427C42.0358 67.4233 41.9817 67.3982 41.975 67.3704C41.9271 67.173 41.9513 66.88 41.9585 66.6735C41.9603 66.623 42.016 66.5904 42.048 66.5669Z M40.6943 67.1321C40.8191 67.153 40.936 67.2869 41.0317 67.3716C41.1542 67.48 41.4237 67.6879 41.1695 67.812C41.0876 67.8092 41.0158 67.7625 40.9621 67.7028C40.8385 67.5656 40.3611 67.2943 40.6943 67.1321Z M43.4219 67.1438C43.8481 67.107 43.4716 67.5211 43.3303 67.6065C43.2635 67.6469 43.1738 67.753 43.0893 67.8062C43.0803 67.807 43.0712 67.8075 43.0621 67.8078C42.8636 67.8144 42.8801 67.6303 42.9968 67.5192C43.1355 67.3873 43.2758 67.2672 43.4219 67.1438Z"
    }
    else {
      var viewbox = "-853 -1600 2471.4 2458.1";
    }
    let svg = '<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="24.714mm" height="24.481mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"  ' +
      '   viewBox="'
      + viewbox +
      '"    xmlns:xlink="http://www.w3.org/1999/xlink"> <path class="fil0" d="'
      + path
      + '" fill="'
      + color
      + '"/> </svg>';
    const src = 'data:image/svg+xml;charset=utf-8,'
      + encodeURIComponent(svg);
    return src;
  }

  async moveVehicleInMap(action, type) {
    if (this.commonService.myPlatform != "desktop") {
      if (this.seperateUrlLogin) {
        this.seprateCard('block')
      }
    }
    let assignedWorkZone
    if (this.entrypoint == "WFT") {
      assignedWorkZone = this.selectedVin.empDetails.workZone == "null" ? [] : (this.selectedVin.empDetails.workZone).split(",");
    }


    if (this.trackHistoryJson) {
      if (type == "default") {
        (this.display == "play") ? this.display = 'pause' : this.display = 'play';
        (this.display == "play") ? this.show = true : this.show = false;
        this.showSpeedSelector = false;
      }
      if (type == "trigger") {
        clearInterval(this.interval);
      }
      if (action == "play") {
        this.playbackUpdater.status = true;
      }
      //this.playbackIcon = 'assets/vtsicon/CAR/Running.svg';

      var icon = this.commonService.vehicleModelmap[this.traveVinData.icon.toUpperCase()]


      this.playbackIcon = this.getLiveTrackIcon(this.commonService.color["Running"], icon)
      if (this.trackHistoryJson.length) {
        if (this.liveCount == 0) {
          this.mapService.clearLayers(this.map, [1, 2])
          var latitude = parseFloat(this.trackHistoryJson[0]['latitude']);
          var longitude = parseFloat(this.trackHistoryJson[0]['longitude']);
          var len = this.trackHistoryJson.length - 1;
          this.mapService.addMarker(this.map, { lat: latitude, lng: longitude }, 'playback', this.playbackIcon);
        }
        this.gpsEnable = false;
        this.gsmEnable = false;
        if (action == 'play') {
          this.showspeedicon = false;
          this.displayPlay = true;
          this.displayStop = false;
          this.displayPause = false;
          this.playback = this.startInterval(this.playBackSpeed);
          await this.intervalLoop();
        } else if (action == 'pause') {
          this.showspeedicon = false;
          this.displayPlay = false;
          this.displayPause = true;
          this.displayStop = false;
          clearInterval(this.interval);
        } else {
          this.showspeedicon = true;
          this.displayPlay = false;
          this.displayPause = true;
          this.displayStop = true;
          this.liveCount = 0;
          this.mapService.removeMarkersById(this.map, 'playback');

          this.show = true
          clearInterval(this.interval);
          this.display = 'play'
          this.playbackUpdater.status = false;
          this.trackHistoryData(this.trackHistoryCurrentRes);
        }
      }
    } else {
      // this.commonService.presentToast("No tracks to play");
    }
    if (this.entrypoint == "WFT") {
      assignedWorkZone.map(res => {
        if (this.geofenceCreatedList[res.split("#")[0] + "-freeForm"] && this.geofenceCreatedList[res.split("#")[0] + "-freeForm"].name == res.split("#")[1])
          this.createFreeForm({ latlng: this.geofenceCreatedList[res.split("#")[0] + "-freeForm"].latlng })
      })

    }
    this.mapService.fitBounds(this.map, 2);
  }
  datas;

  async intervalLoop() {
    while (this.liveCount < this.trackHistoryJson.length) {
      var latitude = parseFloat(this.trackHistoryJson[this.liveCount]['latitude']);
      var longitude = parseFloat(this.trackHistoryJson[this.liveCount]['longitude']);
      if (this.trackHistoryJson[this.liveCount]['vehicleStatus'] != "") {
        this.traveVinData['status'] = this.trackHistoryJson[this.liveCount]['vehicleStatus'];
      } else if (this.trackHistoryJson[this.liveCount]['vehicleStatus'] == "") {
        this.traveVinData['status'] = "Running";
      }

      this.traveVinData['latitude'] = parseFloat(this.trackHistoryJson[this.liveCount]['latitude']);
      this.traveVinData['longitude'] = parseFloat(this.trackHistoryJson[this.liveCount]['longitude']);
      this.traveVinData['timeStamp'] = this.trackHistoryJson[this.liveCount].timeStamp.split(" ")[0] + " " + this.trackHistoryJson[this.liveCount].timeStamp.split(" ")[1];
      this.traveVinData['speed'] = this.trackHistoryJson[this.liveCount]['speed'];
      this.traveVinData['location'] = this.trackHistoryJson[this.liveCount]['address'];
      this.traveVinData['odometer'] = "";
      this.datas = "world"
      this.playbackUpdater["timeStamp"] = this.trackHistoryJson[this.liveCount].timeStamp.split(" ")[0] + " " + this.trackHistoryJson[this.liveCount].timeStamp.split(" ")[1];
      this.playbackUpdater["speed"] = this.trackHistoryJson[this.liveCount]['speed'];
      if (this.playBackOdometer == 0) {
        this.playBackOdometer = this.trackHistoryJson[this.liveCount]["odometer"] / 1000;
      } else {
        this.playBackOdometer = this.playBackOdometer + (this.trackHistoryJson[this.liveCount]["odometer"] / 1000);
      }

      this.playbackUpdater["odometer"] = this.playBackOdometer.toFixed(3);
      let lineArray = new Array(2);
      if (this.liveCount > 0) {
        let prevLatLng = {
          "lat": parseFloat(this.trackHistoryJson[this.liveCount - 1]['latitude']),
          "lng": parseFloat(this.trackHistoryJson[this.liveCount - 1]['longitude'])
        }
        let currLatLng = {
          "lat": latitude,
          "lng": longitude
        }
        lineArray = [prevLatLng, currLatLng];
        if (this.trackHistoryJson[this.liveCount]['speed'] != "0" || this.entrypoint == "WFT") {
          this.mapService.moveMarker(this.map, 'playback', longitude, latitude, this.playbackIcon, '', lineArray);
          this.liveCount++;
          break;
        } else if (this.liveCount == this.trackHistoryJson.length - 1) {
          this.mapService.moveMarker(this.map, 'playback', longitude, latitude, this.playbackIcon, '', lineArray);
        } else {
          this.mapService.moveMarker(this.map, 'playback', longitude, latitude, this.playbackIcon, '', lineArray);

        }
        this.liveCount++;
      } else {
        this.liveCount++;
      }

    }
    if (this.liveCount == this.trackHistoryJson.length) {
      this.moveVehicleInMap('pause', 'default')
      this.liveCount = 0;
      this.show = true;
      clearInterval(this.interval);
    }
  }
  seprateCard(ar) {
    if (this.seperateUrlLogin) {
      document.getElementById("septCard").style.display = ar;
    }

  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }



  async delay(milliseconds: number) {
    return new Promise<void>(resolve => {
      setTimeout(resolve, milliseconds);
    });
  }

  async startInterval(milliseconds: number) {
    return new Promise<void>(resolve => {
      this.interval = setInterval(async () => {
        await this.intervalLoop();
      }, milliseconds);
    });
  }
  playbackSpeedTrigger(speed) {
    if (speed >= 0 && speed <= 125) {
      this.playBackSpeed = 1000;
    } else if (speed >= 125 && speed <= 250) {
      this.playBackSpeed = 500;
    } else if (speed >= 250 && speed <= 500) {
      this.playBackSpeed = 125;
    } else if (speed >= 500 && speed <= 1000) {
      this.playBackSpeed = 65;
    }

    if (this.display == "pause")
      this.moveVehicleInMap("play", "trigger");
  }


  ngOnChanges() {

    if (this.gridLiveChange) {
      if (this.type == "Multi Track")
        this.selectedVin = this.gridLiveChange;
      else
        this.selectedVin = JSON.parse(localStorage.selectedVin);
      this.traveVinData = this.selectedVin;
      if (localStorage.pageSelector != "Multi Track")
        this.ngOnInit();
    }
    if (this.seperateUrlLogin == true) {
      if (this.type == "Multi Track")
        this.selectedVin = this.gridLiveChange;
      else
        this.selectedVin = JSON.parse(localStorage.selectedVin);
      this.traveVinData = this.selectedVin;
    }

  }
  showRange() {
    this.showHideRangeArrow = !this.showHideRangeArrow
  }
  showFenceInMap() {
    this.geofenceCreatedList = [];
    let url = serverUrl.web + "/Alert/GeozoneDatas?data=" + localStorage.corpId;
    this.ajaxService.ajaxGetJson(url).subscribe((res) => {
      this.geofenceCreatedList = res.Freeform;
    });

  }

  changeArView(data) {
    if (app.entryPoint == 'WFT')
      return 'arabicPlateNo'
    return data
  }

  splitNameArabic(data) {
    if (localStorage.seprateLogin !== 'true')
      return this.commonService.splitNameArabic(data, this.directory);
  }

  alertAPI() {
    this.commonService.presentLoader();
    let currentDate = new Date();
    let currentTime = currentDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    if (this.commonService.myPlatform != 'desktop') {
      let fromDate = this.datePipe.transform(this.user.fromDate, 'yyyy-MM-dd') + " " + this.datePipe.transform(this.user.fromDate, 'HH:mm:ss');
      this.replacedfromDate = fromDate.toString();
      let toDate = this.user.toDate;
      // this.replacedtoDate = toDate.split("T").join(" ");
      this.replacedtoDate = this.datePipe.transform(this.user.fromDate, 'yyyy-MM-dd') + " " + this.datePipe.transform(this.user.toDate, 'HH:mm:ss');
      var data = {
        "address": "false",
        "vin": this.selectedVin.vin,
        "userId": localStorage.userName,
        "companyId": localStorage.corpId,
        "fromDate": this.replacedfromDate,
        "toDate": this.replacedtoDate,
        "currentTime": currentTime
      };

    }
    else {
      var data = {
        "address": "false",
        "vin": this.selectedVin.vin,
        "userId": localStorage.userName,
        "companyId": localStorage.corpId,
        "fromDate": this.userSelected.fromDate,
        "toDate": this.userSelected.toDate,
        "currentTime": currentTime
      };
    }
    if (((this.userSelected.fromDate && this.userSelected.toDate) || (this.replacedfromDate && this.replacedtoDate)) && (this.vins || this.selectedVin.vin)) {
      const url = serverUrl.web + "/alert/mobileAlert";
      this.ajaxService.ajaxPostWithBody(url, data)
        .subscribe(res => {
          if (res.length == 0) {
            this.closeDiv("track-Alert");
            this.commonService.presentAlert(this.trans.instant("Warning"), this.trans.instant("Alerts not found"));
            this.show = true;

          } else {
            this.allAlts = res;
          }
          this.commonService.dismissLoader();

        })
    }
  }
  close() {
    this.showHistoryCard = true;
  }
  trackAlert() {
    this.trackAlertDis = "block";
    this.show = false;
    this.alertAPI();
  }
  openDiv() {
    this.trackIdDis = 'block';
    this.showHistoryCard = true;
  }
  trackDetail() {
    this.trackDetailAPI();
    this.show = false;
    this.closeDiv("track-Alert");
  }
  trackDetailAPI() {
    this.commonService.presentLoader();
    if (this.userSelected.fromDate && this.commonService.myPlatform == "desktop") {
      var fromDate: any = this.userSelected.fromDate.split(" ")[0];
      var startTime: any = this.userSelected.fromDate.split(' ')[1];
      var endTime: any = this.userSelected.toDate.split(' ')[1];
    }

    else if (this.commonService.myPlatform != "desktop") {
      var fromDate: any = this.datePipe.transform(this.user.fromDate, 'yyyy-MM-dd');
      var startTime: any = this.datePipe.transform(this.user.fromDate, 'HH:mm:ss');
      var endTime: any = this.datePipe.transform(this.user.toDate, 'HH:mm:ss')
    }
    else {
      var fromDate: any = this.user.fromDate.split('T')[0];
      var startTime: any = this.user.fromDate.split('T')[1];
      var endTime: any = this.user.toDate.split('T')[1];
    }

    const url = `${serverUrl.web}/report/trackReport?vehicleNo=${this.selectedVin.vin}&fromDate=${fromDate}&fromtime=${startTime}&totime=${endTime}`;
    this.ajaxService.ajaxGet(url)
      .subscribe(res => {
        if (res.trackHistory.length == 0) {
          this.commonService.dismissLoader();
          this.closeDiv("track-id");
          this.commonService.presentAlert(this.trans.instant("Warning"), this.trans.instant("No Data"));

        }
        else {
          this.commonService.dismissLoader();
          this.showData = res;
          this.openDiv();
          this.closeDiv("track-id");
          this.openDiv();
        }
      }, error => {
        console.error('Error fetching track data:', error);
      });

  }
  closeDiv(ev) {
    if (ev == "track-id") { this.trackIdDis = 'none'; this.show = true; }
    else if (ev == "track-Alert") { this.trackAlertDis = "none" }
    if (ev == "track-id") { this.showHistoryCard = false };
    this.showHistoryCard = false;
  }
  saveURL(tok) {
    let require;
    if (this.multiURL) {
      if (this.commonService.myPlatform == "desktop") {
        require = this.selectedVin.vin + "/" + this.dateTime + "/" + app.entryPoint + "/" + localStorage.corpId + "/" + tok + "/" + this.colorTrack;
      } else {
        require = this.selectedVin.vin + "/" + this.mobileDate + "/" + app.entryPoint + "/" + localStorage.corpId + "/" + tok + "/" + this.colorTrack;;
      }
    }
    else {
      if (this.commonService.myPlatform == "desktop") {
        require = this.selectedVin.vin + "/" + this.userSelected.fromDate.replace(" ", "T") + "#" + this.userSelected.toDate.replace(" ", "T") + "/" + app.entryPoint + "/" + localStorage.corpId + "/" + tok;
      } else {
        // require = this.selectedVin.vin + "/" + this.user.fromDate.replace(" ", "T") + "#" + this.user.toDate.replace(" ", "T") + "/" + app.entryPoint + "/" + localStorage.corpId + "/" + tok;
        require = this.selectedVin.vin + "/" + this.datePipe.transform(this.user.fromDate, 'yyyy-MM-dd') + "T" + this.datePipe.transform(this.user.fromDate, 'HH:mm:ss') + "#" + this.datePipe.transform(this.user.fromDate, 'yyyy-MM-dd') + "T" + this.datePipe.transform(this.user.toDate, 'HH:mm:ss') + "/" + app.entryPoint + "/" + localStorage.corpId + "/" + tok;
      }
    }
    let fullUrl = document.location.href + "/" + require
    //  let fullUrl = "https://arabiandynamics.net" + "/" + require
    const url = serverUrl.web + '/device/trackApigenerate';
    let data = {
      "fullURL": fullUrl,
    }
    this.ajaxService.ajaxPostMethod(url, data)
      .subscribe(res => {
        let final = document.location.href.split("/#/")[0] + "/#/$tracking$/" + res.shortURL;
        // let final = "https://arabiandynamics.net" + "/#/$tracking$/" + res.shortURL;

        if (this.commonService.myPlatform == "desktop") {
          this.copy(final);
        } else {
          this.copyToMobileClipboard(final)
        }

      })
  }
  copyToMobileClipboard(text: string) {
    this.clipboard.copy(text)
      .then(() => {
        console.log('Text copied to mobile clipboard');
      })
      .catch((error) => {
        console.error('Error copying text to mobile clipboard:', error);
      });
    this.commonService.presentToast("Url copied.");
    this.commonService.dismissLoader();
  }
  copy(arg) {
    navigator.clipboard.writeText(arg).then(function () {
      console.log('Copied! uniqe', arg);
    }, function () {
      console.log('Copy error')
      this.commonService.dismissLoader();
      this.commonService.presentToast("Url not generated.");
      return null;
    });
    this.commonService.presentToast("Url copied.");
    this.commonService.dismissLoader();
  }

  mainTrack() {
    this.multiURL = false;
    this.token();
  }


  token() {
    if (this.trackHistoryJson.length == 0) {
      this.urlpresentAlert = true;
      this.multiURL = false;
    } else {
      this.urlpresentAlert = false;
    }
    if (this.urlpresentAlert) {
      if (this.type == "Multi Track")
        this.commonService.presentAlert("No data", "Data not available" + " For " + this.selectedVin.plateNo);
      else
        this.commonService.presentAlert("No data", "Data not available");
      return null;
    }
    this.commonService.presentLoader();
    const url = serverUrl.web + '/authenticatebyuser';
    let data = {
      "companyname": localStorage.corpId,
      "username": localStorage.userName,
      "password": localStorage.password
    }
    this.ajaxService.ajaxPostMethod(url, data)
      .subscribe(res => {
        this.saveURL(res.token);
      })
  }
  radioGroupChange(event) {
    this.radio = event.target.value

    if (this.radio == "callsign") {
      this.vehoerationcode = Object.values(this.dashboardJson);
      this.vehoerationcodesourcs = [];
      this.vehoerationcode.map((res) => {
        if (res.assetName != "")
          this.vehoerationcodesourcs.push(res)
      })
      var source = {
        datatype: 'json',
        datafields: [{ name: 'assetName' }, { name: 'vin' }],
        id: 'id',
        localdata: this.vehoerationcodesourcs
      }
      if (this.vehoerationcodesourcs.length != 0) {
        this.plateNoSelected = this.vehoerationcodesourcs[0].plateNo
        this.selectedVin = this.vehoerationcodesourcs[0];
        this.traveVinData = this.vehoerationcodesourcs[0];
        setTimeout(() => {
          this.plateNoComobox.selectItem(this.vehoerationcodesourcs[0].vin)
        }, 500)
      }
    } else if (this.radio == "plate") {
      this.plateNoList = Object.values(this.dashboardJson);
      this.plateNoList.map((res, index) => {
        this.plateNoList[index]['arabicPlateNo'] = this.plateNoList[index].plateNo.split("@,@").length >= 2 ? this.plateNoList[index].plateNo.split("@,@")[0] + ` (${this.plateNoList[index].plateNo.split("@,@")[1]})` : this.plateNoList[index].plateNo.split("@,@")[0]
      })
      var source = {
        datatype: 'json',
        datafields: [{ name: 'plateNo' }, { name: 'arabicPlateNo' }, { name: 'vin' }],
        id: 'id',
        localdata: this.plateNoList
      }
      this.plateNoSelected = this.plateNoList[0].plateNo
      this.selectedVin = this.plateNoList[0];
      this.traveVinData = this.plateNoList[0];
      setTimeout(() => {
        this.plateNoComobox.selectItem(this.plateNoList[0].vin)
      }, 500)
    }
    this.plateNos = new jqx.dataAdapter(source);

  }
  ngOnInit() {
    this.callsign = localStorage.callsign
    this.route.queryParams.subscribe(params => {
      if (params['type'] == undefined) {
        this.pageSelector = this.type
      } else {
        this.pageSelector = params['type']
      }
    });
    if (document.location.href.split('#')[1] == '/tabs/gridview/All' || this.type == "Multi Track" || this.type == "Track") {
      this.Gridview = true;
      this.Gridview1 = true
    } else {
      this.Gridview = false;
      this.Gridview1 = false;
    }

    if (sessionStorage.seprateLogin == 'true') {
      this.seperateUrlLogin = true;

    } else {
      this.seperateUrlLogin = false;
    }
    this.entrypoint = app.entryPoint



    if (this.commonService.myPlatform == 'desktop') {
      this.platWidth = "23%"
      this.platMargin = "3.5%";
    } else {
      this.platWidth = "100%";
      this.platMargin = "18%";
    }

    this.entrypoint = app.entryPoint
    // coomon end

    if (this.seperateUrlLogin == false) {
      let a: any[] = Object.values(storageVariable.dashboardData.liveDatas);
      for (let i = 0; i < a.length; i++) {
        if (!a[i]['warrantyExpiry'])
          this.dashboardJson.push(a[i]);
      }

      const url1 = serverUrl.web + '/login/getPreferences?key=VehOperCodeFilter&companyId=' + localStorage.corpId;
      this.ajaxService.ajaxGetWithString(url1)
        .subscribe(res => {
          this.callsignfilter = res
        })

      if (this.router.url == "/trackhistory" && this.commonService.myPlatform == "desktop") {
        this.showPlateNo = false;
        this.plateNoList = Object.values(this.dashboardJson);
        this.plateNoList.map((res, index) => {
          this.plateNoList[index]['arabicPlateNo'] = this.plateNoList[index].plateNo.split("@,@").length >= 2 ? this.plateNoList[index].plateNo.split("@,@")[0] + ` (${this.plateNoList[index].plateNo.split("@,@")[1]})` : this.plateNoList[index].plateNo.split("@,@")[0]
        })
        this.vehoerationcode = Object.values(this.dashboardJson);
        this.vehoerationcode.map((res) => {
          if (res.assetName != "")
            this.vehoerationcodesourcs.push(res)
        })
        if (this.radio == "callsign") {
          var source = {
            datatype: 'json',
            datafields: [{ name: 'assetName' }, { name: 'vin' }],
            id: 'id',
            localdata: this.vehoerationcodesourcs
          }
        } else {
          var source = {
            datatype: 'json',
            datafields: [{ name: 'plateNo' }, { name: 'arabicPlateNo' }, { name: 'vin' }],
            id: 'id',
            localdata: this.plateNoList
          }
        }
        this.plateNos = new jqx.dataAdapter(source);
        this.plateNoSelected = this.plateNoList[0].plateNo
        this.selectedVin = this.plateNoList[0];
        this.traveVinData = this.plateNoList[0];
        setTimeout(() => {
          this.plateNoComobox.selectItem(this.plateNoList[0].vin)
        }, 500)

      } else {
        if (localStorage.selectedVin) {
          if (this.type == "Multi Track")
            this.selectedVin = this.gridLiveChange;
          else
            this.selectedVin = JSON.parse(localStorage.selectedVin);
          this.traveVinData = this.selectedVin;
        }
      }
      this.trackModal('today');
      this.createMap();

    } else if (this.seperateUrlLogin == true) {
      if (this.type == "Multi Track")
        this.selectedVin = this.gridLiveChange;
      else
        this.selectedVin = JSON.parse(localStorage.selectedVin);
      this.traveVinData = this.selectedVin;
      this.datas = "hello"
      setTimeout(() => {
        this.map = this.mapService.loadMap(this.mapElement.nativeElement, { lat: this.traveVinData.latitude, lng: this.traveVinData.longitude }, false, false);
        this.mapService.setCenter(this.map, { lat: 17.786351, lng: 78.090820 });
        this.getHistory()
      }, 1000);
      this.user = {
        "fromDate": localStorage.trackDate.split("#")[0].replace("%20", "T"),
        "toDate": localStorage.trackDate.split("#")[1].replace("%20", "T"),
      }

    }

    // this.traveVinData['type'] = "trackhistory";
    this.commonService.updateLanguageDir
      .subscribe(res => {
        this.directory = res == "" ? this.directory : res
      })
    this.showFenceInMap()
  }
  toggle() {
    this.hide = !this.hide
  }


}


